module.exports = {
  SIGN_IN: 'Sign in',
  SIGN_UP_LEEGALITY: 'Sign up with leegality',
  SIGN_UP: 'Sign up',
  UNDER_DEVELOPMENT: 'Under Development',
  HOME: 'Home',
  DASHBOARD: 'Dashboard',
  WORKFLOW: 'Workflow',
  AUTOMATION: 'Automation',
  SEQUENCES_LABEL: 'Sequences',
  RECORDS_NAV_LABEL: 'Records',
  EVENTS_LABEL: 'Events',
  CONNECTORS_LABEL: 'Connectors',
  CREDENTIALS_LABEL: 'Credentials',
  NAV_LOGS_LABEL: 'Logs',
  DOCUMENTS: 'Documents',
  DOCUMENT: 'Document',
  DOCUMENT_SECURITY: 'Document Security',
  ACCOUNT: 'Account',
  DESIGN: 'Design',
  DEMO: 'Demo',
  SWITCH_BACK_HERE: 'Switch back here',
  PREFER_CLASSIC_LOOK: 'Prefer the classic look?',
  WELCOME_MSG: ' 🚀 Welcome to the New Leegality Experience.',
  SIGN_UP_MSG: 'Sign up to get instant access to the Leegality Basic Plan',
  ZERO_LICENSE_FEE: 'Zero license fee',
  FEATURE_LIST: 'See Full Feature List',
  GETTING_STARTED: 'Getting Started',
  INTEGRATING_LEEGALITY_API: 'Integrating Legality API',
  LEEGALI_BOT: 'LeegaliBot',
  OPEN_AI_AGENT: 'Open AI Agent',
  CLOSE_AI_AGENT: 'Close AI Agent',
  OTP_BASED_VIRTUAL_SIGN: 'OTP based Virtual Sign',
  SMART_WORKFLOW_API: 'Smart Workflow API access (3.0)',
  DIGITAL_STAMPING: 'Digital stamping in 31 States/UTs',
  AADHAAR_ESIGN_VERIFICATION: 'Aadhaar eSign Verification',
  CONTACT_SALES: 'Contact Sales',
  LINK_TO_GET_STARTED: 'Links to help you get started',
  SETTINGS: 'Settings',
  BANNER_MSG_SIGN_UP: 'Have an annual budget of more than INR 2 Lakhs for this? Want multiple users? Our advanced business plans might be more suitable for you.',
  LEEGALITY_DASHBOARD: 'Leegality Dashboard',
  MY_ACCOUNT: 'My Account',
  MY_SIGNATURES: 'My Signatures',
  PROVISIONS: 'Provisions',
  PROFILE: 'Profile',
  SIGNATURES: 'Signatures',
  ID: 'Id',
  GENDER: 'Gender',
  COMMUNICATION_ADDRESS: 'Communication Address',
  BILLING_ADDRESS: 'Billing Address',
  PLAN: 'Plan',
  TEAM: 'Team',
  BALANCE: 'Balance',
  LANGUAGES: 'Languages',
  HINDI: 'Hindi',
  ENGLISH: 'English',
  CANCEL: 'Cancel',
  SEND: 'Send',
  DELETE: 'Delete',
  CONFIRM: 'Confirm',
  DISCARD: 'Discard',
  APPLY: 'Apply',
  RESTORE: 'Restore',
  CLEAR: 'Clear',
  SAVE_CHANGES: 'Save changes',
  LEARN_MORE: 'Learn more',
  DISMISS: 'Dismiss',
  DATE: 'Date',
  SELECT_DATE: 'Select date',
  DTP_LAST_7_DAYS: 'Last 7 Days',
  DTP_LAST_30_DAYS: 'Last 30 Days',
  DTP_THIS_MONTH: 'This Month',
  DTP_LAST_MONTH: 'Last Month',
  DTP_TODAY: 'Today',
  DTP_YESTERDAY: 'Yesterday',
  DTP_CANCEL: 'Cancel',
  DTP_APPLY: 'Apply',
  DTP_FROM: 'From',
  DTP_TO: 'To',
  DTP_CUSTOM: 'Custom',
  DTP_YOU: 'You',
  OR: 'OR',
  WELCOME: 'Welcome',
  LEEGALITY_COPYRIGHTS: 'Copyright © 2022 Leegality',
  WELCOME_BACK: 'Welcome back',
  SIGN_IN_TO_LEEGALITY: 'Sign in to Leegality',
  WELCOME_BACK_LOGIN_HELPER: 'Welcome back! Please enter your details.',
  SIGN_IN_WITH_OTP_HELPER: 'Didn\'t set password or forgot your password? You can always sign in with OTP.',
  USERNAME_EMAIL_PHONE_NO_LABEL_HINT: 'Email ID and phone number cannot be used interchangeably to log into the same account',
  USERNAME_EMAIL_PHONE_NO: 'Username - Email ID or Phone Number',
  PASSWORD: 'Password',
  CONFIRM_PASSWORD: 'Confirm Password',
  FORGOT_PASSWORD: 'Forgot Password?',
  SIGN_IN_WITH_OTP: 'Sign in with OTP',
  SIGN_IN_WITH_PASSWORD: 'Sign in with password',
  SIGN_IN_WITH_SSO: 'Sign in with SSO',
  SIGN_IN_WITH_SSO_HELPER: 'Sign in using your organization\'s Single Sign-On provider.',
  CONTINUE_WITH_SSO: 'Continue with SSO',
  SEND_OTP: 'Send OTP',
  DIDNT_RECEIVE_EMAIL: 'Didn\'t receive the OTP?',
  ENTER_YOUR_EMAIL_MOBILE: 'Enter your email or mobile',
  RESEND_OTP_IN: 'Resend OTP in',
  RESEND_OTP: 'Resend OTP',
  RESEND_OTP_VIA: 'Resend OTP via:',
  SMS: 'SMS',
  CALL: 'Call',
  AND: 'and',
  OTP: 'One-Time Password',
  SKIP: 'Skip',
  UPDATE: 'Update',
  EMAIL: 'Email',
  TERMS_OF_SERVICE: 'Terms of Service',
  PRIVACY_POLICY: 'Privacy Policy',
  NAME: 'Name',
  ENTER_YOUR_NAME: 'Enter your name',
  ACTIVITY_LOGS: 'Activity Logs',
  DESK: 'Desk',
  ALL: 'All',
  SENT: 'Sent',
  RECEIVED: 'Received',
  PROCESSING: 'Processing',
  CC: 'CC',
  DRAFTS: 'Drafts',
  OVERVIEW: 'Overview',
  SHORTCUTS: 'Shortcuts',
  ACTION_REQUIRED: 'Action Required',
  WAITING_FOR_OTHERS: 'Waiting for Others',
  EXPIRING_SOON: 'Expiring Soon',
  FAILED: 'Failed',
  REJECTED: 'Rejected',
  ACCEPTED: 'Accepted',
  EXPIRED: 'Expired',
  COMPLETE: 'Complete',
  COMPLETED: 'Completed',
  TOOLS: 'Tools',
  STAMPS: 'Stamps',
  NEW: 'New',
  RUN_WORKFLOW: 'Run Workflow',
  NEW_DOCUMENT: 'New Document',
  SWITCH_ACCOUNT: 'Switch Account',
  WALLET: 'Wallet',
  DEPARTMENT: 'Department',
  NOTIFICATIONS: 'Notifications',
  ADMIN: 'Admin',
  ALL_ROLES: 'All Roles',
  PREVIOUS: 'Previous',
  NEXT: 'Next',
  SIGN: 'Sign',
  SIGNER: 'Signer',
  REVIEW: 'Review',
  REVIEWER: 'Reviewer',
  REACTIVATE: 'Re-Activate',
  RESEND: 'Resend',
  DETAILS: 'Details',
  DOWNLOAD: 'Download',
  DOWNLOAD_COMING_SOON: 'Download functionality coming soon',
  DOWNLOAD_DOCUMENT: 'Download Document',
  DOWNLOAD_DOCUMENTS: 'Download Document(s)',
  DOWNLOAD_FORM_FIELDS: 'Download Form Fields',
  PREVIEW_DOCUMENTS: 'Preview Document(s)',
  DONE: 'Done',
  PREVIEW: 'Preview',
  EDIT: 'Edit',
  ATTACHMENTS: 'Attachments',
  SHARE: 'Share',
  REJECT: 'Reject',
  LOGOUT: 'Logout',
  VALID: 'Valid',

  ACCESS_DENIED: 'Access Denied',
  GO_BACK: 'Go Back',
  BACK: 'Back',
  NO_FAILURE_REASON: 'No failure reason',
  GET_OTP: 'Get OTP',

  MULTI_FACTOR_AUTHENTICATION: 'Multi-Factor Authentication',
  MULTI_FACTOR_AUTHENTICATION_HELPER:
    'Enter the 6 digit OTP from your authenticator app',

  MSG_WELCOME: 'Welcome to the Leegality Frontend',
  MSG_LANDING_PAGE:
    'This is the landing page of the web-app. It maps to the "/" (root) path.',
  MSG_GO_TO_SIGN_IN: 'Go to Sign-in',
  MSG_GO_TO_SIGN_UP: 'Go to Sign-up',
  MSG_GO_TO_DASHBOARD: 'Go to Dashboard',
  MSG_UNDER_CONSTRUCTION:
    'We are brewing something awesome for you. \nStay tuned!',
  MSG_SIGN_IN_PAGE: 'This is the sign-in page',
  MSG_CLICK_TO_GO_TO_DASHBOARD: 'Click the button to go to the Dashboard.',
  MSG_VAL_TEXT_NOT_EMPTY: '{label} is a required field',
  MSG_VAL_TEXT_NOT_EMPTY_NO_SPACE: '{label} is a required field and cannot contain empty spaces',
  MSG_VAL_TEXT_MIN_CHAR_COUNT: 'Should be minimum {text_min_char_count} characters',
  MSG_VAL_TEXT_MAX_CHAR_COUNT: 'Should be maximum {text_max_char_count} characters',
  MSG_VAL_TEXT_TEL_NUMBER: 'Please enter a valid mobile number',
  MSG_VAL_TEXT_NUMBER: 'Please enter a valid number',
  MSG_VAL_TEXT_ALL_NO_NUMBER: 'Please remove numbers from the text',
  MSG_VAL_TEXT_EMAIL: 'Please enter a valid email address',
  MSG_VAL_TEXT_URL: 'Please enter a valid URL',
  MSG_VAL_TEXT_EMAIL_OR_TELEPHONE: 'Please enter a valid 10 digit phone number or email ID',
  CUSTOM_MSG_VAL_EMAIL_DUPLICATE: 'Duplicate value, please enter a different email address',
  MSG_SIGN_IN_TNC: 'By proceeding, you agree to the',
  MSG_USERNAME_PASSWORD_DONT_MATCH: 'Username and password do not match. Please try again.',
  MSG_PASSWORD_DONT_MATCH: 'Passwords do not match',
  MSG_GO_TO_PDF_EDITOR: 'Go to Pdf Editor',
  MSG_ALPHA_NUM_WITH_PUNC_CHAR: 'Please remove special characters',
  MSG_ALPHA_NUM_WITH_SUM_CHAR: 'Only +-:(),_.&/@\'– special characters allowed.',
  MSG_VAL_TEXT_MIN_SPECIAL_CHAR_COUNT: '{label} should have a special character',
  MSG_VAL_NO_CONSECUTIVE_NUMBERS: '{label} should not have consecutive numbers',
  MSG_VAL_ONE_LOWER_CHAR_CASE: '{label} should have a lowercase character',
  MSG_VAL_ONE_UPPER_CHAR_CASE: '{label} should have a uppercase character',
  MSG_VAL_MIN_ONE_DIGIT: '{label} should have minimum one digit',
  MSG_VAL_PASSWORD: 'Password should have atleast one lowercase character, one uppercase character, one number, one special character, should be 8 characters long and should not have 3 consecutive character.',
  MSG_VAL_ALL_CHARS_WITH_DOT_AND_SPACE: 'Only characters a-z, A-Z, space & dot allowed.',
  MSG_VAL_TEXT_MATCH: '{name} does not match.',
  CURRENTLY_IN: 'Currently in ',
  MSG_ALPHA_NUM_WITH_DOT_HYPHEN: '{label} should only contain A-Z, a-z, 0-9 and special character (., -, space).',
  MSG_ALPHA_NUM_WITH_CHAR: 'Allowed input includes alphanumeric characters and + - : () , _ . & / @ \' –',
  MSG_ALPHA_NUM_WITH_CHAR_II: 'Please enter valid name. Only alphanumeric and . _ - and space is allowed.',
  MSG_ALPHA_NUM_WITH_CHAR_III: 'Allowed input includes alphanumeric characters and | - : () , _ . [ ] & /',
  MSG_ALPHA_NUM_WITH_SPECIAL_CHAR: 'Only alphanumeric and special character + | - : () , _. [] & / @ # ; \' – " = ! ? % " " \' \' are allowed',
  MSG_ALPHA_NUM_WITH_SPECIAL_CHAR_II: 'Allowed input includes alphanumeric character and + | - : () , _. [] & / " @ # ; \' * " " \' \' are allowed',
  MSG_ALPHA_NUM_WITH_SPECIAL_CHAR_III: 'Allowed input includes alphanumeric characters and + - : () , _ . & / @ \' – ?',
  MSG_ALPHA_NUM_WITH_SPECIAL_CHAR_IV: 'Allowed input includes alphanumeric character and + - : () , _. [] & / " @ ! % ; \' * " " \' \' are allowed',
  MSG_ALPHA_NUMERIC: 'Only letters and numbers are allowed. The value must start with a letter.',
  MSG_EMAIL_WITH_SPECIAL_CHAR: 'Please enter a valid email address. Allowed input includes alphanumeric character and  space, + | - : () , _. [] & / @ – \' ‘ ’ ! # $ % & * = ? ^ ` \xa0 ¬ \xad × é í … } { ~ ',
  ACCOUNT_IMPERSONATOR_MESSAGE: 'account',
  GREY_SWIFT_PRIVATE_LIMITED: 'Grey Swift Private Limited',
  SWITCH_BACK_TO_ACCOUNT: 'Switch back to my account',
  MENU_IMPERSONATOR_MODE_MESSAGE_P1: 'You are currently in',
  MENU_IMPERSONATOR_MODE_MESSAGE_P2: "'s account.",
  IMPERSONATOR_MODE: 'Impersonator Mode',

  MSG_ACCESS_DENIED:
    'Sorry, you do not have permission to access this page. \nPlease contact your administrator.',

  DASHBOARD_HEADER_DESCRIPTION:
    'Send, track & manage your documents & eSign invitations.',

  INVITATION_SENT: 'Invitations Sent',
  INVITATION_SIGNED: 'Invitations Signed',
  DOCUMENTS_COMPLETED: 'Documents Completed',

  DAYS: 'Days',
  WEEKS: 'Weeks',
  MONTHS: 'Months',
  HOURS: 'Hours',

  ESIGN_BALANCE: 'eSign Balance',
  ESIGN_CREDITS_BALANCE: 'eSign credits Balance',
  ESIGN_CREDITS_LEFT: 'eSign credits Left',
  MSG_ESIGN_CREDITS_CONSUMED: 'consumed from the last purchase amount.',
  MSG_REDIRECT_TO_WALLET_TAB: ' Click to redirect to the wallet tab.',
  MSG_FIRST_PURCHASE: 'Make your first purchase',
  MSG__SEND_FIRST_DOCUMENT: 'Send out your first document for execution',
  WATCH_TUTORIAL: 'Watch tutorial',
  BUY_ESIGN_CREDITS: 'Buy eSign Credits',
  MSG_LOW_WALLET_BALANCE: 'You’ve consumed {percentage} of your last purchase!',
  MSG_OUT_OF_BALANCE: 'You’ve run out of eSign Balance',
  MSG_CONTACT_ADMIN: 'Kindly contact your organisation admin',
  ORGANISATION_ADMIN: 'Organisation Admin',
  INITIATE_DOC_EXECUTION: 'Initiate Document Execution',
  HELP_AND_FAQ: 'Help & FAQs',
  ESIGN_LOW_BALANCE_POPUP_USER:
    'Contact an admin or billing user to make a purchase.',
  ESIGN_LOW_BALANCE_POPUP_ADMIN:
    "Click on the 'Buy eSign Credits' button to make a purchase.",

  SENT_DOCUMENTS: 'Sent Documents',
  SENT_DOCUMENTS_DESCRIPTION: 'Manage the documents sent from your Leegality account.',
  SENT_DOCUMENTS_SEARCH_PLACEHOLDER: 'Search in Sent folder',
  EMPTY_LOGS_TABLE_TEXT: 'No logs found',
  NO_DOCUMENTS_FOUND: 'No documents found',
  MSG_COPY_CLIPBOARD_SUCCESS: 'Successfully copied to clipboard!',
  EMPTY_ATTACHMENTS_USER: 'No attachments found for this user',
  EMPTY_ATTACHMENTS_DOCUMENT: 'No attachments found for this document',
  DELETE_ACTION_HEADER: 'Delete Document',
  DELETE_PACK: 'Delete Pack',
  DELETE_PACK_DESCRIPTION: 'Are you sure you want to delete this pack? This action cannot be undone.',
  DELETE_SELECTED_PACKS: 'Delete selected packs',
  DELETE_SELECTED_PACKS_DESCRIPTION:
    'Are you sure you want to delete the selected packs? This action cannot be undone.',
  PACKS_DELETED_SUCCESSFULLY: 'Packs deleted successfully',
  SOME_PACKS_COULD_NOT_BE_DELETED: 'Some packs could not be deleted',
  FAILED_TO_DELETE_PACKS: 'Failed to delete packs',
  DELETE_ACTION_DESCRIPTION:
    'Are you sure you want to delete this document? This action cannot be undone.',
  EDIT_PACK: 'Edit Pack',
  DELETE_INVITEE: 'Delete Invitee',
  PACK_EDIT_DELETE_UNSIGNED_DOCUMENT: 'This document is unsigned. Deleting it must be done via Pack Edit.',
  PACK_EDIT_DELETE_PARTIALLY_SIGNED_DOCUMENT:
    "You can't delete a partially signed document. To remove it from subsequent invitees' flow, unassign it in Pack Edit.",
  PACK_EDIT_DELETE_UNSIGNED_INVITEE: 'This invitee is unsigned. Deleting them must be done via Pack Edit.',
  DELETE_GROUP: 'Delete Group',
  PACK_EDIT_DELETE_GROUP: 'Removing a group must be done via Pack Edit.',
  DELETE_CC: 'Delete CC',
  PACK_EDIT_DELETE_CC: 'Removing a CC must be done via Pack Edit.',
  PACK_EDIT_COMPLETE_INVITEE:
    'Unsigned documents must be unassigned in Pack Edit before this invitee can be marked complete.',
  PACK_EDIT_COMPLETE_GROUP:
    'Unsigned documents must be unassigned in Pack Edit before this group can be marked complete.',
  EDIT_PACK_TO_ADD_OR_REMOVE_ATTACHMENTS: 'To add or remove attachments edit this Pack.',
  LISTING_PACK_EDIT_DELETE_UNSIGNED_DOCUMENT: 'Deleting this document must be done via Pack Edit.',
  PACK_EDIT_BULK_DELETE_BLOCKED:
    'One or more selected documents belong to a pack. Deleting them must be done via Pack Edit.',

  DELETE_SELECTED_ROWS_HEADER: 'Delete selected documents',
  DELETE_SELECTED_ROWS_DESCRIPTION:
    'Are you sure you want to delete the selected documents? This action cannot be undone.',

  SHARE_MODAL_HEADER: 'Share this document',
  SHARE_PACK_HEADER: 'Share this pack',
  SHARE_MODAL_DESCRIPTION: 'You can add upto 15 email IDs in a go',
  ADD_ANOTHER: 'Add Another',
  SAVE_FILTER: 'Save filter',
  ADVANCED_FILTERS: 'Advanced Filters',
  FILTERS_MODAL_HEADER: 'Select Filters',
  FILTERS_MODAL_DESCRIPTION:
    'Add filter properties and values (wherever applicable)',
  SAVE_FILTER_MODAL_DESCRIPTION:
    'Please provide a name and description to this filter',
  VIEW_NAME: 'View name',
  VIEW_DESCRIPTION: 'View description',
  FILTER_NAME: 'Filter name',
  FILTER_DESCRIPTION: 'Filter description',
  ESIGN_LOGS_HEADER: 'Recent eSigning Logs',
  RECENT_ESIGN_ACTIVITY: 'Recent eSigning Activity',
  TRANSACTIONS_OVERVIEW: 'Transactions Overview',
  TRANSACTIONS_OVERVIEW_DESCRIPTION: 'Track and see your documents and eSign transactions till date',
  HOURLY: 'Hourly',
  DAILY: 'Daily',
  WEEKLY: 'Weekly',
  MONTHLY: 'Monthly',
  FILTER_SAVED_SUCCESS_MESSAGE: 'Filter saved successfully',
  FILTER_SAVED_SUCCESS_DESCRIPTION:
    'Your filters have been saved and can be accessed in the Filters tab or from the Associated filters dropdown.',

  USER: 'User',
  USERS: 'Users',
  FROM_USER: 'From User',
  REMARKS: 'Remarks',
  VIEW_ATTACHMENTS: 'View Attachments',
  VIEW_PROFILE: 'View Profile',
  USER_ACCESS_MANAGEMENT: 'User Access Management',
  MSG_VIEW_ATTACHMENTS_SUPPORTING_TEXT:
    'View attachments shared by senders or invitees',
  MSG_TEXT_DELETE_DOC_SUCCESS: 'Document deleted successfully.',
  MSG_TEXT_DELETE_DOC_PARTIAL_SUCCESS: 'Failed to deleted some of the selected documents.',
  MSG_HELPER_DELETE_DOC_SUCCESS:
    'None of the invitees would be able to access the document anymore.',
  MSG_TEXT_SOMETHING_WENT_WRONG:
    'Something went wrong. Please try again.',
  MSG_TEXT_SUCEESS: 'Action performed successfully',
  MSG_HELPER_SOMETHING_WENT_WRONG:
    'If the issue persists, email us at support@leegality.com for further assistance.',
  MSG_TEXT_SHARE_DOC_SUCCESS: 'Document shared successfully.',
  ENTER_PURCHASED_BY: 'Enter Purchased By',
  ENTER_STAMP_DUTY_PAID_BY: 'Select Stamp Duty By',
  DOCUMENT_INFORMATION: 'Document Information',
  STAMP_PAPER_DETAILS: 'Stamp Paper Details',
  EG_EXPIRING_TODAY: 'e.g. Expiring Today',
  EG_EXPIRING_TODAY_DESC:
    'e.g. All received documents that will expire by today mid-night',
  VIEW_FILTER: 'View Filter',
  SENT_DATE: 'Sent date',
  EXPIRES_IN: 'Expires in',
  IRN: 'IRN',
  DOCUMENT_ID: 'Document ID',
  STAMP_DOC_ID: 'Stamp Doc ID',
  VIEW_STAMP_DETAILS: 'View stamp details',
  ERROR_CODE: 'Error Code',
  STATUS: 'Status',
  SHARING: 'Sharing',
  COMPLETED_FRACTION: '{completed}/{total} completed',
  UNDER_PROGRESS: 'Under Progress',
  MORE: 'more',
  PAGE: 'Page',
  OF: 'of',
  ATTACHMENT_PREVIEW: 'Attachment Preview:',
  DOCUMENT_INFORMATION_CREATED_USING: 'Created Using:',
  DOCUMENT_INFORMATION_FOLDER: 'Folder:',
  LAST_ACTIVITY: 'Last Activity:',
  DOCUMENT_PREVIEW: 'Document Preview',

  NEW_WORKFLOW: 'New Workflow',
  SOURCE: 'Source',
  DENOMINATION: 'Denomination',
  DENOMINATION_WITH_RUPEE: 'Denomination (₹)',
  SERIES_NO: 'Series No.',
  STAMP_SERIAL_NO: 'Stamp Serial No.',
  LOAD_MORE_PAGES: 'Load More Pages',
  SERIES: 'Series',
  GROUPS: 'Groups',

  REFRESH: 'Refresh',
  MSG_ESIGN_LOGS_HELPER: 'See details of all events here',
  NOT_FOUND: 'Not found (404)',
  MSG_NOT_FOUND: 'The page you were looking for doesnt exist.',

  SAVE_FILTER_MODAL_HEADER_COPY: 'Clone filter',
  SAVE_FILTER_MODAL_DESCRIPTION_COPY:
    'Cloning will create a separate filter with the same configurations. Please enter the name & description for this filter.',

  FOLDERS: 'Folders',
  MOVE_TO_FOLDER: 'Move to folder',
  NEW_FOLDER_NAME: 'New folder name',
  NO_FOLDER: 'No folder',
  CREATE_FOLDER: 'Create folder',
  MOVE_HERE: 'Move here',
  MOVE_TO: 'Move to',
  MOVE: 'Move',
  CREATE: 'Create',
  MSG_MOVE_TO_FOLDER_NO_FOLDER_HELPER: 'Create a new folder by clicking the \'Create folder\' button',
  MSG_MOVE_TO_FOLDER_NO_FOLDER_HELPER_USER: 'Contact an admin for creating new folders',
  MSG_MOVE_TO_FOLDER_SUCCESS: 'Documents moved successfully',
  MSG_HELPER_MOVE_TO_FOLDER_SUCCESS:
    'You can browse the folders and their documents from the Folders menu',
  MSG_CREATE_FOLDER_SUCCESS: 'Folder created successfully',
  MSG_HELPER_CREATE_FOLDER_SUCCESS:
    'You can now move your documents to the newly created folder',
  EXTEND_DOCUMENT_EXPIRY: 'Extend Document Expiry',
  EXTEND_INVITATION_EXPIRY: 'Extend Invitation Expiry',
  EXTEND_DOCUMENT_EXPIRY_DESCRIPTION:
    'Select or enter the new expiry period in days',

  EXTEND_BY_ORIGINAL_TIMELINE: 'Extend by original timeline',
  EXTEND_BY_MINUTES: 'Extend by 45 minutes',
  EXTEND_BY_DAY: 'Extend till 11:59 PM today',
  EXTEND_BY: 'Extend by',
  DAYS_FROM_TODAY: 'days from today',
  MSG_REACTIVATE_CUSTOM_EXPIRY_HELPER:
    'Number of days can range from 1-365. Expires at 11:59 PM',
  EXPIRY_EXTENDED: 'Document Reactivated Successfully',
  SENT_TO: 'Sent to',
  DELETE_FILTER: 'Delete Filter',
  DELETE_FILTER_DESCRIPTION:
    'Are you sure you want to delete this filter? This action cannot be undone.',
  MSG_FILTER_DELETED: 'Filter has been deleted',
  MSG_FILTER_DELETED_HELPER:
    'A filter associated with this folder has been deleted.',
  SAVE_FILTER_MODAL_HEADER_EDIT: 'Edit filter name & description',
  SUCCESSFULLY_UPDATED: 'Successfully updated',
  CHANGES_SAVED_ACRROSS_APPLICATION:
    'Your changes have been saved and applied across the application.',

  DRAG_AND_DROP: 'or drag and drop',
  CLICK_TO_UPLOAD_LABEL: 'Click to Upload',
  CLICK_TO_REUPLOAD_LABEL: 'Click to re-upload',
  CLICK_TO_REPLACE_PFX_FILE_LABEL: 'Click to replace PFX file',
  UPLOAD_MORE_FILES_LABEL: 'Upload more files',
  CREATED_FORM: 'Created from:',

  FORM_MODAL_HEADER: 'Unsaved changes',
  FORM_MODAL_DESCRIPTION:
    'Are you sure you want to close this form? All filled details will be lost',

  MAXIMUM_VALUE: 'Maximum Value',
  ASSOCIATED_STAMP_SERIES: 'Associated Stamp Series',

  SERIES_PAGE_HEADER_HELPER: 'Create and manage your stamp inventory here',
  ACTIVITY_LOGS_PAGE_HEADER_HELPER: 'View all activity logs here',
  HELP: 'Help',
  PURCHASE: 'Purchase',
  HISTORY: 'History',
  EXTEND_EXPIRY: 'Extend Expiry',
  EDIT_ICON: 'Edit Icon',
  REMAINING: 'Remaining',
  INFO: 'Info',
  USED: 'Used',
  BLOCKED: 'Blocked',
  UNUSED: 'Unused',
  IN_PROCESS: 'In Process',
  IN_PROCESS_PLEASE_WAIT: 'In Process. Please Wait!',
  EXPORT: 'Export',
  TOTAL: 'Total',
  STAR: 'Star',
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
  DISABLED: 'Disabled',
  TABLE_PAGINATION_BRIEF: '{range} of {total} records',
  SEARCH: 'Search',
  SEARCH_WITH_DOTS: 'Search...',
  SEARCH_PACK_NAME: 'Search Pack Name',
  SEARCH_DOC_NAME: 'Search Doc Name',
  COLUMNS: 'Columns',
  STATE: 'State',
  NOTHING_SELECTED: 'Nothing Selected',
  STAMP_GROUPS: 'Stamp Groups',
  ATTACH_MULTIPLE_STAMP_SERIES: 'Attach multiple stamp series',
  RECEIVED_INVITATIONS: 'Received Invitations',
  RECEIVED_DOCUMENTS_DESCRIPTION:
    'Track and action your received invitations here',
  RECEIVED_ON: 'Received On',
  DRAFT: 'Draft',
  GROUP: 'Group',
  SELECTED_LOWER: 'selected',
  ORDER_ID: 'Order ID',
  ORDER_DATE: 'Order Date',
  ESTIMATED_DUE_DATE: 'Estimated Due Date',
  UPDATED_DUE_DATE: 'Updated due date',
  REASON_FOR_DELAY: 'Reason for delay',
  NEEDS_ATTENTION: 'Needs Attention',
  NEED_ATTENTION_DESCRIPTION: 'Warnings and Errors associated with this series',
  LOW_BALANCE: 'Low Balance',
  LOW_BALANCE_CARD_DESCRIPTION: 'You have consumed {percent}% of your last purchase quantity.',
  SIGN_REJECT: 'Sign - Reject',
  PENDING_SIGNATURE: 'Pending Signature',
  PENDING_YOUR_SIGNATURE: 'Pending your signature',
  PENDING_REVIEW: 'Pending Review',
  PENDING_YOUR_REVIEW: 'Pending your Review',
  SIGNED: 'Signed',
  DOCUMENT_SIGN_SUCCESS: 'Succesfully signed document',
  DSC_SIGN_FAILURE: 'Error while signing the document from DSC Utility',
  REVIEW_APPROVED: 'Review - Approved',
  REVIEW_REJECTED: 'Review - Rejected',
  YOU_SIGNED: 'You Signed',
  YOU_REVIEWED_APPROVED: 'You Reviewed - Approved',
  YOU_REVIEWED_REJECTED: 'You Reviewed - Rejected',
  INITIATE_BULK_SIGN_VIA: 'Initiate Bulk Sign Via:',
  DEACTIVATE_BULK_SIGN: 'Deactivate Bulk Sign',
  ACTIVATE_BULK_SIGN: 'Activate Bulk Sign',
  SIGNATURE_DETAILS: 'Signature Details',
  BULK_DSC_CONFIRM_MODAL_TITLE: 'DSC Signing in Progress',
  BULK_DSC_CONFIRM_MODAL_DESC: 'Are you sure you want to end the DSC Signing process.',
  BULK_DSC_SIGNER: 'Bulk DSC Signer',
  BULK_DSC_SIGNING: 'Bulk DSC Signing',
  LEEGALITY_DSC_UTILITY: 'Leegality DSC Utility',
  DSC_UTILITY_NOT_FOUND: 'Either the Leegality DSC Utility is not installed or not running.',
  DSC_UTILITY_FOUND: 'Leegality DSC Utility has been detected successfully.',
  DSC_TOKEN_NOT_FOUND: 'Either the DSC token has not been inserted or the required token driver is not installed correctly.',
  DSC_TOKEN_FOUND: 'DSC Token has been detected successfully',
  DSC_CERTIFICATE_NOT_FOUND: 'Unable to fetch certificate from DSC Dongle',
  BULK_DSC_CONSENT: 'By Clicking this checkbox and Sign Documents button, I agree that the Digital Signature Certificate saved in the inserted USB will be used to sign documents for me. I also understand that recipients of such electronic documents will be able to see my signing details.',
  INSERT_DSC_TOKEN: 'Please insert only 1 DSC token into the system.',
  DOWNLOAD_DSC_UTILITY: 'Download for {os}',
  DOWNLOAD_TOKEN_DRIVER: 'Download Token driver',
  DETECTION_FAILED: 'Detection Failed',
  DETECTION_SUCCESSFUL: 'Detection Successful',
  SIGNING_FOR: 'Signing for:',
  DSC_TOKEN: 'DSC Token',
  CLOUD_DSC: 'Cloud DSC',
  CLOUD_DSC_FOREIGNER_SIGN: 'Cloud DSC (Foreigner Sign)',
  SELECT_INVITATION_BULK_SIGNING: 'Select invitations to initiate bulk signing',
  BULK_SIGN: 'Bulk Sign',
  BULK_SIGNING: 'Bulk Signing',
  BACK_TO_RECEIVED_INVITATIONS: 'Back to Received Invitations',
  SEARCH_BY_DOCUMENT: 'Search by Document',
  COMBINATIONS_SELECTED_COUNT: '{count}/{max} selected',
  BULK_SIGN_MAX_COMBINATIONS_DESC: 'You can select up to 500 combinations at a time',
  NO_DOCS_FOR_BULK_SIGNING: 'No documents available for bulk signing',
  BULK_COMBINATIONS_FETCH_FAILED: 'Failed to load documents for bulk signing',
  DETECTING_DSC_CLIENT: 'Detecting Leegality DSC Client',
  PROCESSING_LOADER_MSG: 'Processing...',
  DONT_CLOSE_BROWSER_OR_BACK: "Please don't close the browser or go back.",
  LEEGALITY_DSC_CLIENT: 'Leegality DSC Client',
  DSC_CLIENT_DETECTED: 'Leegality DSC Client detected',
  DSC_CLIENT_NOT_INSTALLED: 'Leegality DSC Client is not installed or not running',
  DSC_TOKEN_DRIVER: 'DSC token driver',
  DSC_TOKEN_NOT_DETECTED_DESC: 'Unable to detect DSC token. Make sure the token driver is installed and the DSC token is connected.',
  WAITING_FOR_DSC_CLIENT: 'Waiting for Leegality DSC Client',
  DSC_TOKEN_DETECTED: 'DSC Token Detected',
  SIGN_DOCUMENTS: 'Sign Documents',
  SIGNING_IN_PROGRESS: 'Signing in progress',
  ENTER_DSC_TOKEN_PIN: 'Please enter your DSC Token PIN',
  SELECT_CERTIFICATE_ON_DSC_CLIENT: 'Please select certificate on Leegality DSC Client',
  ERROR_OCCURRED: 'Error Occurred',
  DSC_TOKEN_NOT_CONNECTED: 'Token is not connected to the system. Make sure token driver is successfully installed in your system.',
  DONT_CLOSE_WHILE_SIGNING: 'Please do not close or reload the screen while bulk signing is underway.',
  DOCS_ESIGNED_SUCCESS: 'Documents eSigned successfully:',
  DOCS_FAILED_ESIGN: 'Documents failed to eSign:',
  SIGNING_PROCESSED: 'Signing Processed',
  SIGNING_PROCESSED_DESC: 'The signing process is done. Kindly review the summary of the documents below.',
  SIGNING_STOPPED: 'Signing Stopped',
  SIGNING_STOPPED_DESC: 'The signing process stopped unexpectedly due to some reason. Documents already signed are unaffected.',
  BULK_SIGNING_IN_PROGRESS: 'Bulk Signing is in progress',
  BULK_SIGNING_INTERRUPT_DESC: 'Leaving now will interrupt the signing process. Few documents are still queued. Documents already signed will not be affected.',
  EXIT_ANYWAY: 'Exit anyway',
  CONTINUE_SIGNING: 'Continue Signing',
  MORE_COUNT: '+{count} more',
  I_AGREE_THAT: 'I agree that',
  ACTION_CANCELLED_BY_USER: 'The action was cancelled by the user',
  OKAY: 'Okay',
  SELECTION_LIMIT_EXCEEDED: 'Selection limit exceeded',
  INVITATION_SELECTED: 'invitations selected',
  FILES_SELECTED_SINGULAR: '{count} file selected',
  FILES_SELECTED_PLURAL: '{count} files selected',
  REJECT_SIGN_INVITATION: 'Reject Sign Invitation',
  REJECT_INVITATION_DESCRIPTION: 'Are you sure you want to reject this Sign invitation? This action cannot be undone.',
  ENTER_REASON_FOR_REJECTION_OPTIONAL: 'Enter your reason for rejection (Optional)',
  EXPIRING_SOON_CARD_DESCRIPTION: '{stampCount} stamp papers in this series are expiring in the next {expiringInDays} days.',
  EXTEND_STAMP_EXPIRY: 'Extend Stamp Expiry',
  PURCHASE_DATE: 'Purchase Date',
  EXPIRY_DATE: 'Expiry Date',
  HEALTHY: 'Healthy',
  QUANTITY: 'Quantity',
  EXTEND_BY_HINT_DAYS: 'Extend By (Days)',
  EXTEND: 'Extend',
  DOCUMENT_EXPIRING_IN_DAYS_HOURS_MINUTES:
    'This document is expiring in {days} days, {hours} hours, {minutes} minutes',
  CREATE_STAMP_SERIES: 'Create Stamp Series',
  STAMP_SERIES_DETAILS: 'Stamp Series Details',
  STAMP_PAPER_INFORMATION: 'Stamp Paper Information',
  STAMP_PAPER_INFORMATION_HELPER: 'This information will be used to purchase your stamp papers',
  ADDITIONAL_INFORMATION: 'Additional Information',
  ADDITIONAL_INFORMATION_HELPER:
    'This section records information regarding the authorised signatory of the procuring party . This section is optional',
  LEGEND_CONFIGURATION: 'Legend Configuration',
  LEGEND_CONFIGURATION_HELPER: 'This content will be printed on every paper procured for this series.',
  SHIPPING_INFORMATION: 'Shipping Information',
  SHIPPING_INFORMATION_HELPER: 'This information will be used for delivery of your physical stamps (if applicable).',
  SERIES_NAME: 'Series Name',
  SERIES_NAME_HELPER: 'Enter a name to identify this stamp series.',
  FIRST_PARTY_NAME: 'First Party Name',
  SECOND_PARTY_NAME: 'Second Party Name',
  PURPOSE_ARTICLE_CODE: 'Purpose/Article Code',
  AUTHORISED_SIGNATORY_NAME_OF_PROCURING_PARTY: 'Authorised Signatory Name of procuring party',
  AUTHORISED_SIGNATORY_NAME_OF_PROCURING_PARTY_HELPER: 'Enter the name of the authorised signatory for the Purchaser',
  AUTHORISED_SIGNATORY_ID_PROOF: 'Authorised Signatory ID Proof',
  AUTHORISED_SIGNATORY_ID_PROOF_HELPER:
    'Upload a valid government issued ID proof of the authirised signatory.  .',
  REGISTERED_ADDRESS_OF_PROCURING_PARTY:
    'Registered Address of procuring party',
  REGISTERED_ADDRESS_OF_PROCURING_PARTY_HELPER:
    'Enter the registered address of the purchasing entity.',
  LEGEND_CONTENT: 'Legend Content',
  SHIPPING_ADDRESS: 'Shipping Address',
  ENTER_SHIPPING_ADDRESS: 'Enter Shipping Address',
  PINCODE: 'Pincode',
  CITY_TOWN: 'City/Town',
  ADDRESS: 'Address',
  PHONE_NUMBER: 'Phone Number',
  PAN: 'PAN',
  ENTER_PAN: 'Enter PAN',
  SAVE: 'Save',
  PREVIEW_SAMPLE: 'Preview Sample',
  ENTER_SERIES_NAME: 'Enter Series Name',
  SELECT_STATE: 'Select State',
  SELECT_DENOMINATION: 'Select Denomination',
  ENTER_FIRST_PARTY_NAME: 'Enter First Party Name',
  ENTER_SECOND_PARTY_NAME: 'Enter Second Party Name',
  ENTER_PROPOSE_ARTICLE_CODE: 'Enter Purpose/Article Code',
  ENTER_PINCODE: 'Enter Pincode',
  ENTER_CITY_TOWN: 'Enter City/Town',
  ENTER_STATE: 'Enter State',
  ENTER_ADDRESS: 'Enter Address',
  ENTER_CONTENT: 'Enter Content',
  ENTER_NAME: 'Enter Name',
  PURCHASED_BY: 'Purchased By',
  ENTER_PHONE_NUMBER: 'Enter Phone Number',
  GROUP_INFORMATION: 'Group Information',
  GROUP_INFORMATION_HELPER: 'Lorem Ipsum',
  GROUP_NAME: 'Group Name',
  CREATE_STAMP_GROUP: 'Create Stamp Group',
  ENTER_GROUP_NAME: 'Enter Group Name',
  MAXIMUM_STAMP_VALUE: 'Maximum Stamp Value (₹)',
  MAXIMUM_STAMP_DUTY_CAN_BE_GENERATED_FROM_GROUP: 'Maximum value of stamp duty that can be generated from this group.',
  ENTER_MAXIMUM_STAMP_VALUE_LIMIT: 'Enter Maximum Stamp Value',
  SERIES_NUMBER: 'Series Number',
  CC_DOCUMENTS_DESCRIPTION: 'Track your CC invitations here',
  PURCHASE_MODAL_DESCRIPTION:
    'Enter purchase quantities for the series you want to purchase',
  REMOVE: 'Remove',
  REPLACE: 'Replace',
  PREVIOUS_PURCHASE: 'Previous Purchase',
  MARK_AS_ACTIVE: 'Mark as Active',
  MARK_AS_INACTIVE: 'Mark as Inactive',
  OPEN: 'Open',
  SHOW: 'Show',
  CLOSE: 'Close',
  ESIGNED: 'eSigned',
  EXISTING_PURCHASE: 'Existing Purchase',
  NEW_SELECTION: 'New Selection',
  DISCARD_AND_CREATE_NEW: 'Discard and Create New',
  EXISTING_PURCHASE_REQUEST: 'Existing Purchase Request',
  ACTIVE_PURCHASES: 'Active Purchases',
  STAMP_SERIAL_NUMBER: 'Stamp Serial Number',
  EXISTING_PURCHASE_REQUEST_MODAL_DESCRIPTION:
    'Review the existing request below and check whether you want to cancel this process or replace the existing purchase request with a new one',
  PURCHASE_STAMPS_TIP: 'Running out of stamps?',
  PURCHASE_STAMPS_TIP_DESC:
    "Now you can buy stamps by clicking on the 'Cart' icon against the relevant series or by selecting multiple series to initiate a bulk purchase",
  BACK_TO_ALL_SERIES: 'Back to all series',
  NOT_STARRED: 'Not starred',
  STARRED: 'Starred',
  ACTIVATE: 'Activate',
  DEACTIVATE: 'Deactivate',
  MSG_SUCCESSFULLY_STARRED: 'Successfully starred!',
  MSG_SUCCESSFULLY_UNSTARRED: 'Successfully unstarred!',
  MSG_HELPER_SUCCESSFULLY_STARRED: "You've successfully starred the series",
  MSG_HELPER_SUCCESSFULLY_UNSTARRED:
    "You've successfully removed the series from starred list",
  MSG_EXTEND_EXPIRY_SUCCESS: 'Successfully extended the expiry',
  MSG_HELPER_EXTEND_EXPIRY_SUCCESS:
    'Your request to extend the expiry of stamps has been processed successfully',
  VIEW: 'View',
  BLOCK: 'Block',
  GENERATE_REPORT_HEADER: 'Select Data Points to be added to the report',
  DOCUMENT_ID_HELPER: 'Unique IDs assigned to each stamp paper by Leegality',
  STAMP_SERIAL_NUMBER_HELPER:
    'Serial Number associated with each stamp provided by the issuing authority',
  STATUS_HELPER: 'Status of the stamp paper in your leegality stamp inventory',
  LAST_UPDATED_ON_HELPER: 'Date and Time when a stamp paper was last updated',
  EXPIRY_DATE_HELPER: 'Date of expiry of the stamp paper',
  PURCHASE_DATE_HELPER: 'Date of purchase of the stamp paper',
  LAST_UPDATED_ON: 'Last Updated on',
  LAST_UPDATED: 'Last Updated',
  GENERATE_REPORT: 'Generate Report',
  BLOCK_STAMP: 'Block Stamp',
  BLOCK_STAMP_DESCRIPTION: 'Are you sure you want to block this stamp paper? This will remove the paper from digital usage.',
  BLOCK_ACTION_HEADER: 'Block selected stamps?',
  BLOCK_ACTION_DESCRIPTION: 'Are you sure you want to block the selected stamp papers? This will remove the papers from digital usage.',
  UNBLOCK_ACTION_HEADER: 'Unblock selected stamp?',
  UNBLOCK_ACTION_DESCRIPTION:
    'Are you sure you want to unblock this stamp paper? This will add the paper back to the digital inventory.',
  ORDER_QUANTITY: 'Order Quantity',
  REQUEST_ID: 'Request ID',
  ORIGINAL_DUE_DATE: 'Original Due Date',
  ON_TRACK: 'On Track',
  DELAYED: 'Delayed',
  BALANCE_REMAINING: 'Balance Remaining',
  CONSUMED: 'Consumed',
  ACTIVE_STAMP_PROCUREMENT: 'Active Stamp Procurement',
  ASSOCIATED_GROUPS: 'Associated Groups',
  ASSOCIATED_GROUPS_DESC: 'List of groups this series is associated with',
  MSG_MARK_AS_ACTIVE_HELPER: 'Are you sure you want to activate this series?',
  MSG_MARK_AS_ACTIVE_GROUP_HELPER:
    'Are you sure you want to activate this group?',
  MSG_MARK_AS_INACTIVE_HELPER:
    'Are you sure you want to deactivate this series?',
  MSG_MARK_AS_INACTIVE_GROUP_HELPER:
    'Are you sure you want to deactivate this group?',
  MSG_SUCCESSFULLY_ACTIVATED: 'Successfully activated!',
  MSG_SUCCESSFULLY_DEACTIVATED: 'Successfully deactivated!',
  MSG_HELPER_SUCCESSFULLY_ACTIVATED: 'You\'ve successfully activated the series',
  MSG_HELPER_SUCCESSFULLY_DEACTIVATED: 'You\'ve successfully deactivated the series',
  MSG_HELPER_STAMP_SUCCESSFULLY_BLOCKED: 'You\'ve successfully blocked the stamp',
  MSG_SUCCESSFULLY_BLOCKED: 'Successfully blocked!',
  YES: 'Yes',
  NO: 'No',
  EXCITING_UPDATE_AHEAD: 'Exciting Updates Ahead!',
  WORKFLOWS: 'Workflows',
  WORKFLOW_DETAILS: 'Workflow Details',
  WORKFLOW_DOCUMENTS: 'Workflow Documents',
  WORKFLOWS_PAGE_HEADER_HELPER: 'Create and manage your workflows here',
  CRAFTING_ENC_WORKFLOW_EXP: 'We\'re crafting an enhanced workflow experience. Get ready for something amazing! Launching soon.',
  CONTACT_BOOK: 'Contact Book',
  REPORTS: 'Reports',
  CUSTOM_FIELDS: 'Custom Fields',
  MANAGE_YOUR_ORG_CUSTOM_FIELDS: 'Manage your organisation\'s Custom Fields',
  TEMPLATES: 'Templates',
  UPLOAD_EXCEL: 'Upload Excel',
  DOWNLOAD_TEMPLATE_XLSX: 'Download Template (xlsx)',
  DOWNLOAD_INPUT_FILE: 'Download Input File',
  DOWNLOAD_OUTPUT_FILE: 'Download Output File',
  GENERATE_LATEST_REPORT: 'Generate Latest Report',
  DOWNLOAD_REPORT: 'Download Report',
  CUSTOM_MAPPING: 'Custom Mapping',
  VIEW_API_PAYLOAD: 'View API Payload',
  CLONE: 'Clone',
  ARCHIVE: 'Archive',
  UNARCHIVE: 'Unarchive',
  TYPE: 'Type',
  REPORT_TYPE: 'Report Type',
  REPORT_TYPE_TABLE_HEADER: 'Report type',
  PDF: 'PDF',
  TEMPLATE: 'Template',
  CREATED_ON: 'Created On',
  DELETE_WORKFLOW: 'Delete workflow',
  DELETE_WORKFLOW_HELPER: 'Are you sure you want to delete this workflow? This action cannot be undone.',
  ARCHIVED_WORKFLOW: 'Archived workflow',
  CLONE_WORKFLOW: 'Clone Workflow',
  EG_WEBSITE_DESIGN: 'e.g. Website design',
  DELETED_SUCCESSFULY: 'Deleted successfully',
  EXCEL_UPLOAD_SUCCESS: 'Excel uploaded successfully.',
  ENTER_WORKFLOW_NAME: 'Please enter a name for this workflow',
  WORKFLOW_DELETE_SUCCESS_MSG: 'Workflow has been successfully deleted',
  UPLOAD_EXCEL_SEND_INVITATIONS: 'Upload excel to send out invitations.',
  MSG_WORKFLOW_TEMPLATE_DOWNLOAD_SUCCESS: 'Download will begin shortly!',
  MSG_DOWNLOAD_PACK_DOCS_BEGIN: 'Downloading all pack documents',
  MSG_DOWNLOAD_PACK_DOCS_FAIL: 'Failed to download pack documents',
  MSG_DOWNLOAD_DOC: 'Downloading document',
  MSG_DOWNLOAD_AUDIT_TRAIL: 'Downloading audit trail',
  MSG_DOWNLOAD_DOC_FAILED: 'Downloading failed',
  MSG_WORKFLOW_TEMPLATE_DOWNLOAD_SUCCESS_HELPER:
    'The template file is in the xlsx format which can be filled in and used to run the workflow',
  MSG_EXCEL_UPLOAD_FORMAT_SUPPORT: 'Supported Formats: .xls or .xlsx',
  CUSTOM_EXCEL_MAPPING: 'Custom Excel Mapping',
  EXCEL_COLUMN_HEADERS: 'Leegality Excel Column Headers',
  UPLOADED_FILE_COLUMN_HEADERS: 'Uploaded File Column Headers',
  SELECT_HEADER: 'Select header',
  MSG_CUSTOM_MAPPINGS_SAVE_SUCCESS: 'Mappings saved successfully',
  MSG_CUSTOM_MAPPING_DELETED_SUCCESS: 'Mapping deleted successfully',
  DELETE_MAPPING: 'Delete Mapping',
  REUPLOAD_EXCEL: 'Re-upload Excel',
  UPLOAD: 'Upload',
  INPUT: 'Input',
  BOOLEAN: 'Boolean',
  INPUT_FIELD: 'Input Field',
  DROPDOWN: 'Dropdown',
  TOGGLE: 'Toggle',
  API_NAME: 'Api Name',
  DEFAULT_VALUE: 'Default Value',
  DISPLAY_TEXT: 'Display Text',
  CREATE_CUSTOM_FIELD: 'Create Custom Field',
  START_CREATING_YOUR_FIRST_CUSTOM_FIELD: 'Start by creating your first Custom Field',
  EDIT_CUSTOM_FIELDS: 'Edit Custom Fields',
  DELETE_CUSTOM_FIELDS: 'Delete Custom Fields',
  CUSTOM_FIELD_DELETE_CONFIRM: 'Are you sure you want to delete this custom field? This action cannot be undone.',
  EDIT_CUSTOM_FIELD: 'Edit Custom Field',
  VIEW_CUSTOM_FIELD: 'View Custom Field',
  SET_UP_CUSTOM_FIELD_DESC: 'Set up the custom field here: Save values added during Workflow Run',
  DISPLAY_NAME: 'Display Name',
  SUBSCRIPT: 'Subscript',
  FIELD_DESCRIPTION: 'Field Description',
  VALIDATIONS: 'Validations',
  FIELD_TYPE: 'Field Type',
  TYPE_HERE: 'Type here',
  ENTER_HERE: 'Enter here',
  ENTER_VALUE: 'Enter value',
  MIN: 'Min',
  MAX: 'Max',
  PLACEHOLDER_TEXT: 'Placeholder Text',
  TEXT_SHOWN_BEFORE_USER_ENTERS: 'Text shown before the user enters a value',
  REGEX: 'Regex',
  MIN_CHAR_LIMIT: 'Min Char Limit',
  MAX_CHAR_LIMIT: 'Max Char Limit',
  CUSTOM_REGEX: 'Custom Regex',
  CUSTOM_REGEX_EG: 'e.g., ^[a-zA-Z0-9]+$ or ^[\\w-.]+@([\\w-]+\\.)+[\\w-]{2,4}$',
  MAX_CHAR_LESS_THAN_MIN_ERROR: 'Max characters cannot be less than Min characters',
  INPUT_NOT_MATCH_REQUIRED_REGEX_PATTERN: 'Error: The input does not match the required regex pattern',
  THIS_INPUT_IS_NOT_VALID: 'This input is not valid',
  MIN_NUMBER_OF_CHAR_ALLOWED: 'The minimum number of characters allowed is {min_char_allowed}',
  MAX_NUMBER_OF_CHAR_ALLOWED: 'The maximum number of characters allowed is {max_char_allowed}',
  ENTER_VALID_REGEX_PATTERN: 'Please enter a valid regex pattern',
  DROPDOWN_VALUES: 'Dropdown values',
  DEFAULT_SELECTION: 'Default selection',
  SELECTION_TYPE: 'Selection type',
  SINGLE_SELECT: 'Single Select',
  MULTIPLE_SELECT: 'Multiple Select',
  DROPDOWN_VALUE_REQUIRED: 'Dropdown value is required',
  AT_LEAST_ONE_DROPDOWN_VALUE_REQUIRED: 'Atleast one dropdown value is required',
  THIS_VALUE_ALREADY_EXISTS: 'This value already exists',
  DEFAULT_SELECTION_REQUIRED: 'Default selection is required',
  TOGGLE_ON: 'Toggle on',
  TOGGLE_OFF: 'Toggle off',
  SELECT_FILE_FORMAT: 'Select File Format',
  SELECT_FORMAT: 'Select format',
  FILE_FORMAT_PDF_HINT: 'Note: If you want to link this to a document upload field, then please select PDF only.',
  MAX_ALLOWABLE_SIZE: 'Max Allowable Size',
  ENTER_SIZE: 'Enter size',
  FILE_SIZE_RANGE_HINT: 'Range: {min}KB to {max}KB',
  CUSTOM_FIELD_DELETE_SUCCESS_MSG: 'Custom field deleted successfully',
  FAILED_TO_DELETE_CUSTOM_FIELD: 'Failed to delete custom field',
  DOWNLOAD_EXCEL: 'Download Excel',
  CREATE_WORKFLOW: 'Create Workflow',
  WORKFLOW_NAME: 'Workflow Name',
  WORKFLOW_ID: 'Workflow ID',
  WORKFLOW_TYPE: 'Workflow Type',
  UPLOAD_EMAIL: 'Upload Email',
  AUTHORIZED_EMAILS: 'Authorized Email ID(s)',
  NO_AUTH_EMAILS: 'No Email IDs configured',
  VIA_DASHBOARD: 'Via Dashboard',
  VIA_API: 'Via API',
  VIA_EXCEL_UPLOAD: 'Via Excel Upload',
  EXCEL_UPLOAD: 'Excel Upload',
  GENERATING: 'Generating...',
  EMPTY_DOC_HISTORY: 'You have not sent out any documents via {mode} using this workflow',
  WORKFLOW_DRAFT: 'Workflow is in Draft state',
  WORKFLOW_DRAFT_TEXT: 'Organisation admin needs to complete the workflow setup in order to enable document execution',
  WORKFLOW_DRAFT_TEXT_ADMIN: 'Complete the workflow setup in order to send out document for execution',
  CONTINUE_WORKFLOW_SETUP: 'Continue Workflow Setup',
  WORKFLOW_NAME_PLACEHOLDER: 'e.g. Home Loan Indeminity',
  NO_WORKFLOWS_EXIST: 'No Workflows exist',
  NO_WORKFLOWS_EXIST_HELPER: 'There are no Workflows set up. Try creating one.',
  CLEAR_FILTERS: 'Clear Search/Filters',
  APPLY_FILTERS: 'Apply Filters',
  CLEAR_ALL: 'Clear All',
  GROUP_SERIES_PURCHASE_TABLE_HEADER:
    'Stamp Series in  Group: {group_number} - {group_name}',
  RUN: 'Run',
  CONTINUE: 'Continue',
  DOCUMENT_CONFIGURATION: 'Document Configuration',
  DOCUMENT_CONFIGURATION_HELPER:
    'This is the first step where you configure your document',
  INVITEE_CONFIGURATION: 'Invitee Configuration',
  INVITEE_CONFIGURATION_HELPER:
    'This is the second step where you configure your invitees',
  SIGNATURE_PLACEMENTS: 'Signature Placement',
  SIGNATURE_PLACEMENTS_HELPER:
    'This is the third step where you configure your signature placements',
  EDIT_WORKFLOW: 'Edit Workflow',
  EDIT_WORKFLOW_HELPER: 'Choose which part of the workflow you want to edit',
  CONTACTS_PAGE_HEADER_HELPER: 'Create and manage your contacts here',
  IMPORT: 'Import',
  LABEL_OPTIONAL: 'Label(s) (Optional)',
  EMAIL_ID: 'Email ID',
  ADD_CONTACT: 'Add Contact',
  CONTACTS_BOOK_BANNER:
    'You can only perform actions on personally owned contacts',
  LABEL: 'Label',
  OWNERSHIP: 'Ownership',
  CONTACT_NAME: 'Contact Name',
  DELETE_CONTACT: 'Delete contact',
  DELETE_ESIGN: 'Delete eSign ID:',
  DELETE_CLOUD_DSC: 'Delete Signer ID',
  DELETE_ESIGN_DESC: 'Are you sure you want to delete this eSign ID? This action cannot be undone.',
  DELETE_CLOUD_DSC_DESC: 'Are you sure you want to delete this Signer ID? This action cannot be undone.',
  DELETE_CONTACT_HELPER: 'Are you sure you want to delete this contact? This action cannot be undone.',
  BULK_DELETE_CONTACT: 'Delete selected contacts',
  BULK_DELETE_CONTACT_HELPER: 'Are you sure you want to delete the selected contacts? This action cannot be undone.',
  SEND_CONTACT: 'Send Contact',
  SEND_CONTACT_HELPER: 'Select users who you want to send this/these contact(s) to.',
  NO_CONTACTS_FOUND_HELPER:
    'Start by creating a contact. All your organisation, shared and personal contacts will be diplayed here.',
  MSG_TEXT_SEND_CONTACT_SUCCESS: 'Contact(s) sent successfully.',
  MSG_TEXT_SEND_CONTACT_HELPER_SUCCESS:
    'The contact(s) have been successfully sent to the selected users and will be visible in their contact book as personal contacts.',
  MSG_TEXT_DELETE_CONTACT_SUCCESS: 'Contact deleted successfully',
  EDIT_CONTACT: 'Edit Contact',
  ACTION_EDIT_CONTACT: 'Edit contact',
  IMPORT_CONTACT: 'Import Contacts',
  IMPORT_CONTACT_HELPER:
    'Note: Name and either email ID/Phone number are mandatory.',
  DOWNLOAD_REFERENCE_FILE: 'Download Reference File',
  CONTACT_UPLOAD_FORMAT_SUPPORT_MSG: 'Supported Formats: .xls or .xlsx',
  DOC_SIGNER_UPLOAD_FORMAT: 'Supported Formats: .pfx',
  DOC_SIGNER_PASSWORD_HELPER: 'This is the password for your pfx file',
  DOC_SIGNER_MAIL_LIST_HELPER: 'Note : The configured emails will receive reminder notifications as the certificate nears expiry and an expiry notification upon expiration.',
  MSG_TEXT_CREATE_CONTACT_SUCCESS: 'Contact created successfully.',
  MSG_TEXT_UPDATE_CONTACT_SUCCESS: 'Contact updated successfully.',
  LABELS: 'Labels',
  RETRY: 'Retry',
  STAY_ON_PAGE: 'Stay on this page',
  LEAVE_THIS_PAGE: 'Leave this page',
  SAVE_AS_DRAFT: 'Save as draft',
  CLOSE_FORM_MODAL_DESCRIPTION:
    'Are you sure you want to leave this page? All unsaved changes will be lost.',
  CONTINUE_FILLING: 'Continue filling',
  MSG_TEXT_CREATE_CONTACT_HELPER_SUCCESS:
    'The contact has been added to your contact book and can be used in the sending journey.',
  REMOVE_LABEL: 'Click to remove label',
  SHARE_CONTACT_TEXT: 'Share this contact with other users in the organisation',
  DUPLICATE_INPUT_FOUND: 'Duplicate input found',
  USE_COMMAS_TO_SEPARATE_LABELS: 'Use commas to add and separate labels',
  STAMP_GROUP_EXPIRING_SOON_CARD_DESCRIPTION: 'Stamp Papers in the following series associated with this group are expiring within the next {expiringInDays} days.',
  STAMP_GROUP_LOW_BALANCE_CARD_DESCRIPTION: 'The following series associated with this group are running low on balance.',
  TEMPLATE_PAGE_HEADER_HELPER: 'Create and manage your stamp inventory here',
  TEMPLATE_ID: 'Template ID',
  TEMPLATE_TYPE: 'Template Type',
  TEXT: 'Text',
  CREATE_TEMPLATE: 'Create Template',
  CREATE_TEMPLATE_DESCRIPTION_FILE_UPLOAD:
    'Upload the pdf files for your template',
  CREATE_TEMPLATE_DESCRIPTION_TEMPLATE_TYPE:
    'Enter and a name and configure a type for your template',
  TEMPLATE_NAME: 'Template Name',
  ENTER_TEMPLATE_NAME: 'Enter Template Name',
  PDF_EDITOR: 'PDF Editor',
  CREATE_TEMPLATE_PDF_EDITOR_DESCRIPTION:
    'Start with an existing PDF file and add dynamic fields on top of it',
  TEXT_EDITOR: 'Text Editor',
  CREATE_TEMPLATE_TEXT_EDITOR_DESCRIPTION:
    'Start from a blank template in Leegality’s HTML based template engine',
  DRAG_FILES_TO_REARRANGE_THEM_AS_NEEDED:
    'Drag files to rearrange them as needed.',
  PROCEED: 'Proceed',
  SUPPORTED_FORMATS: 'Supported Formats: {mimeTypes}',
  CREATE_TEMPLATE_FILE_UPLOAD_MAX_NUMBER_OF_FILES_MSG: '{numberOfFilesUploaded} out {maxNumberOfFilesAllowed} Files Uploaded',
  CREATE_TEMPLATE_FILE_UPLOAD_MAX_TOTAL_FILE_SIZE_MSG: '{sizeOfUploadedFiles} out of {maxUploadSizeLimit} used',
  CREATE_TEMPLATE_UPLOAD_ERROR_MSG: 'Upload limit exceeded, delete some files in order to proceed',
  DELETE_TEMPLATE: 'Delete template',
  DELETE_TEMPLATE_HELPER: 'Are you sure you want to delete this template? This action cannot be undone.',
  BULK_DELETE_TEMPLATE: 'Delete selected templates',
  BULK_DELETE_TEMPLATE_HELPER: 'Are you sure you want to delete the selected templates? This action cannot be undone.',
  MSG_TEXT_DELETE_TEMPLATE_SUCCESS: 'This template has been deleted',
  MSG_TEXT_BULK_DELETE_TEMPLATE_SUCCESS: 'Selected templates have been deleted successfully.',
  MSG_ERROR_TEMPLATE_DELETE_WORKFLOW_CONFIGURED: 'Template is linked with a workflow',
  MSG_ASSOCIATED_WORKFLOW_CANNOT_BE_DELETED: ' cannot be deleted as it is associated with a workflow.',
  MSG_TEXT_BULK_DELETE_TEMPLATE_ERROR: 'One or more selected templates have not been deleted.',
  NO_STATE_SELECTED: 'No State Selected',
  ADD: 'Add',
  MSG_CONTACT_LABELS_LIMIT: 'Only {number} labels are allowed per contact.',
  QUICK_ACCESS: 'Quick Access',
  NESL_ERRORS: 'NeSL Errors',
  NESL_TXN_ID: 'NeSL Txn ID',
  TRANSACTION_ID: 'Transaction ID',
  ERROR_TYPE: 'Error Type',
  ERROR_DESCRIPTION: 'Error Description',
  SANCTION_NUMBER: 'Sanction Number',
  NESL_BUCKET_CAN_RETRY: 'Temporary Submission Issue',
  NESL_BUCKET_CAN_REFRESH: 'NeSL Update Failed',
  NESL_BUCKET_OTHER: 'Other Errors',
  NESL_ERRORS_EMPTY_TITLE: 'No NeSL submission errors',
  NESL_ERRORS_EMPTY_SUBTITLE: 'Documents with failed NeSL submissions will show up here for you to retry or refresh.',
  NESL_RETRY_SUCCESS: 'Retry submitted successfully.',
  NESL_RETRY_FAILED: 'Retry failed. Please try again.',
  NESL_REFRESH_SUCCESS: 'NeSL status refreshed.',
  NESL_REFRESH_FAILED: 'Could not refresh NeSL status. Please try again.',
  DISCLAIMER: 'Disclaimer',
  EXTEND_EXPIRY_DISCLAIMER_TEXT: 'The legal validity of stamps is governed by the respective state laws. Extention of expiry timelines on Leegality will not result in extention of validity from a legal perspective.',
  FILTERS: 'Filters',
  PROCUREMENT_DETAILS: 'Procurement Details',
  ORDER_TRACKING: 'Order Tracking',
  ORDER_DETAILS: 'Order Details',
  MSG_CLICK_BUTTON_TO_BUY_ESIGN_BALANCE:
    'Click on the button below to purchase eSign credits in order to send documents out for execution.',
  MSG_ORG_HAS_NO_USERS: 'Your Organisation does not have any users',
  NO_ORG_USERS_FOUND: 'No organisation users found',
  MSG_SERIES_SUCCESFULLY_UPDATED: 'Stamp Series Details updated successfully',
  MSG_HELPER_SERIES_SUCCESFULLY_UPDATED: 'All future orders will be processed with the updated information',
  DAYS_AGO: 'days ago',
  STAMP_SERIES_DETAILS_UPDATED_SUCCESSFULLY: 'Stamp Series Details updated successfully',
  MSG_All_FUTURE_ORDERS_PROCESSED_WITH_UPDATED_INFO: 'All future orders will be processed with the updated information',
  LEFT: 'left',
  CONCURRENT_LOGIN_HEADER: 'Duplicate login detected',
  CONCURRENT_LOGIN_HEADER_HELPER:
    'You are already logged into this account from other browsers/devices.',
  PROCEED_CURRENT_ACCOUNT: 'Proceed with your current account',
  LOG_IN_DIFFERENT_ACCOUNT: 'Log into a different account',
  MSG_DUPLICATE_LOGIN:
    'Proceeding with the current account will log you out of the account in the other browsers/devices.',
  OTP_SUCCESS: 'OTP triggered to the given username',
  MSG_WORKFLOWS_CONFIGURED: '{x} out of {y} workflows configured',
  GOOGLE: 'Google',
  MSG_CONTACT_ADMIN_EXTEND_EXPIRY:
    'Contact your organisation admin for expiry extension.',
  MSG_NO_ACTIVE_PROCUREMENT: 'No active procurements currently',
  MSG_CONTACT_ADMIN_OR_BILLING_USER_FOR_PURCHASE: 'You have consumed x% of the last purchase quantity. Contact your organisation admin/billing user for purchasing additional stamp papers.',
  MSG_NO_RECENT_ACTIVITY: 'No recent activity found',
  RENAME: 'Rename',
  CREATE_SUBFOLDER: 'Create Subfolder',
  DELETE_FOLDER: 'Delete Folder',
  DELETE_FOLDER_HELPER: 'Are you sure you want to delete this folder along with its sub-folders? This action cannot be undone. Note: This will not result in the deletion of the documents.',
  RENAME_FOLDER: 'Rename Folder',
  RENAME_FOLDER_HELPER: 'Edit the name for this folder.',
  CREATE_FOLDER_HELPER: 'Please enter a name for this folder.',
  MSG_RENAME_FOLDER_SUCCESS: 'Folder renamed successfully',
  MSG_DELETE_FOLDER_SUCCESS: 'Folder deleted successfully',
  MSG_SANDBOX_VALIDITY: 'You have sandbox account access till: {date}',
  ADD_TEST_TEMPLATE: 'Add Test Template',
  MSG_USING_TEST_ENV: 'You are using Leegality’s test environment',
  MSG_CREATE_CUSTOM_FILTERS: 'Start by saving a filter from one of the source folders',
  SAVE_AND_UPDATE_FILTER: 'Save & Update Filter',
  CLONE_FILTER: 'Clone Filter',
  CLICK_STAR: 'Click to Star',
  CLICK_UNSTAR: 'Click to Un-Star',
  SERIES_INFORMATION: 'Series Information',
  OPEN_STAMP_SERIES_FORM: 'Open stamp series form',
  CLICK_MARK_ACTIVE: 'Click to mark as active',
  CLICK_MARK_INACTIVE: 'Click to mark as inactive',
  EDIT_GROUP: 'Edit Group',
  UNBLOCK: 'Unblock',
  DELETE_SERIES: 'Delete Series',
  MSG_DELETE_SERIES_HELPER: 'Are you sure you want to delete this stamp series? This action cannot be undone.',
  MSG_CLICK_INITIATE_MAKE_PURCHASE: 'Make your first purchase. Click to initiate a purchase.',
  MSG_MAKE_PURCHASE_CONTACT_ADMIN: 'Make your first purchase. Contact an Admin or billing user to initiate a purchase',
  CLEAR_SELECTION: 'Clear Selection',
  PRESS: 'Press',
  MSG_GO_BACK_TO_EXISTING_MAPPING: 'to go back to existing mapping.',
  CREATE_CONTACT: 'Create Contact',
  DOWNLOAD_API_PAYLOAD: 'Download API Payload',
  VIEW_DETAILS: 'View Details',
  SETTINGS_PROFILE_PIC_LABEL: 'Your photo',
  SETTINGS_PROFILE_PIC_SUPPORT_TEXT: 'This will be displayed on your profile.',
  USERNAME: 'Username',
  SETTINGS_PROFILE_PASSWORD_SUPPORT_TEXT: 'Update your password using your current password or OTP',
  VIA_CURRENT_PASSWORD: 'Via current pasword',
  VIA_OTP: 'Via OTP',
  CURRENT_PASSWORD: 'Current Password',
  NEW_PASSWORD: 'New Password',
  CONFIRM_NEW_PASSWORD: 'Confirm New Password',
  PASSWORD_RESET_BANNER_TEXT: 'You will be logged out after successfully updating the password',
  UPDATE_PASSWORD: 'Update password',
  NEW_PASSWORD_HINT_TEXT: 'Password should have atleast one lowercase character, one uppercase character, one number, one special character, should be 8 characters long and should not have 3 consecutive character.',
  SUCCESSFULLY_UPDATE_PROFILE: 'Successfully updated profile',
  REJECTED_INVITATION: 'Rejected Invitations',
  REVIEWED_APPROVED: 'Review approved',
  REVIEWED_REJECTED: 'Review rejected',
  MSG_ACTION_REQUIRED: 'Drafts and invitations that require your action',
  MSG_WAITING_FOR_OTHERS: 'Documents where you are awaiting other’s action',
  MSG_EXPIRY_SOON: 'Invitations that are expiring within the next 5 days',
  MSG_FAILED: 'Invitations that have failed to complete',
  EMAIL_ID_PHONE_NO: 'Email ID or Phone Number',
  ENTER_YOUR_EMAIL_PHONE_NUMBER: 'Enter your email id or phone number',
  ENTER_EMAIL_ADDRESS: 'Enter email address',
  NO_ACCOUNT_FOUND: 'No account found',
  MSG_COULDNT_FIND_ACCOUNT_CREATE_NEW: 'We couldn\'t find any existing account with this username. Please create a new account to access Leegality',
  EXISTING_ACCOUNT_FOUND: 'Existing account found',
  MSG_EXISTING_ACCOUNT_FOUND_TRY_SIGNING_IN: 'There is an existing account associated with this username, please proceed with the sign-in journey',
  EDIT_STAMP_GROUP: 'Edit Stamp Group',
  CREATE_STAMP_GROUP_SUCCESS: 'Group Created Successfully',
  UPDATE_STAMP_GROUP_SUCCESS: 'Group Updated Successfully',
  STAMP_GROUP_CREATED_AND_LIVE_ORG: 'Stamp Group has been created and is live for your organisation.',
  STAMP_GROUP_UPDATED_AND_LIVE_ORG: 'Stamp Group has been created and is live for your organisation.',
  SERIES_SELECTED: '{count} Series selected',
  UNUSED_STAMPS: '{count} Remaining',
  FILTER_BY: 'Filter By',
  GROUP_QUANTITY: 'Group Quantity',
  QTY_PAPERS: '{count} Papers',
  SIGNER_REJECTED: 'Signer Rejected',
  REVIEWER_REJECTED: 'Reviewer Rejected ',
  INVITATION_EXPIRED: 'Invitation Expired',
  MSG_LIMIT_EXCEEDED_FOR_WORKFLOW_CREATION: 'Limit exceeded for workflow creation.',
  MSG_CREATE_SEND_DOC_FROM_PRE_CONFIG_WORKFLOW: 'Create a new document or send out a document using one of the pre-configured workflows from your account.',
  MSG_CREATE_DOC_ADD_SIGNER_AND_SEND_DOC: 'Create a new document, add signers and send the document out for execution.',
  MSG_NOT_APPLICABLE_TO_AN_ADMIN: 'Not applicable to an admin',
  MSG_SEND_OUT_DOCS_USING_PRE_CONFIG_WORKFLOW: 'Send out documents using one of the pre-configured workflows from your account.',
  MSG_ESIGN_BALANCE_EXHAUSTED: 'eSign balance exhausted',
  NO_ACTIVITY_FOUND: 'No activity found',
  ALL_ACTIVE_SENT_DOCS: 'All your active sent documents',
  START_SENDING_DOC_FOR_EXECUTION: 'Start by sending out a document for execution',
  INVITATIONS_RECEIVED_FOR_SIGNING_OR_REVIEW: 'All invitations you have received for signing/review',
  DOCUMENTS_MARKED_AS_CC: 'All documents where you are marked as a CC',
  DOCUMENTS_YET_TO_SEND_OUT: 'All documents that you are yet to send out',
  DOCUMENTS_FULLY_EXPIRED: 'All documents that have fully expired',
  DOCUMENTS_FULLY_EXECUTED: 'All documents that have been fully executed',
  DRAFTS_INVITATIONS_REQUIRE_ACTION: 'All drafts and invitations that require your action',
  DOCUMENTS_AWAIT_OTHERS_ACTION: 'All documents where you are awaiting other’s action',
  INVITATIONS_EXPIRING_IN_FIVE_DAYS: 'All invitations that are expiring within the next 5 days',
  INVITATIONS_FAILED_TO_COMPLETE: 'All invitations that have failed to complete',
  PROCURE_STAMPS_TO_ENABLE_DUTY_PAYMENT: 'Procure stamps to enable stamp duty payment',
  START_BY_CREATING_STAMP_SERIES: 'Start by creating a stamp series',
  STAMP_PAPERS_CONTAINED_IN_SERIES: 'All stamp papers contained in this series',
  PLACE_STAMP_PAPER_ORDER: 'Start by placing a stamp paper order',
  NO_RECORDS_FOUND: 'No records found',
  ENABLE_GROUP_STAMP_SERIES_DUTY_PAYMENT: 'Group your stamp series to enable dynamic stamp duty payment',
  START_CREATING_STAMP_GROUP: 'Start by creating a stamp group',
  TIRED_CONFIGURING_DOCS_SETTINGS: 'Tired of configuring settings for your documents?',
  NOTHING_HERE_YET: 'Oops! Nothing here yet',
  START_BY_CREATING_FIRST_TEMPLATE: 'Start by creating your first template',
  CREATE_CUSTOM_FIELD_CONTACT_YOUR_ADMIN: 'To create a new custom field, please reach out to your admin.',
  START_CREATING_PRECONFIGURED_WORKFLOW: 'Start by creating a pre-configured workflow',
  START_CREATING_YOUR_FIRST_WORKFLOW: 'Start by creating your first workflow',
  CONFIGURE_CONVERT_FORMS_INTO_TEMPLATES: 'Configure or convert your forms into dynamic templates',
  START_CREATING_TEMPLATE: 'Start by creating a template',
  STOP_LOOKING_FOR_EMAIL_PHONE_NUMBER: 'Time to stop looking for emails and phone numbers',
  START_CREATING_CONTACT: 'Start by creating a contact',
  NO_RESULTS_FOUND: 'No results found',
  NO_RESULT_FOUND: 'No results found',
  NO_RESULTS: 'No Results',
  TRY_ADJUSTING_SEARCH_FILTER: 'Try adjusting your search or filter to find what you’re looking for.',
  ALL_TEMPLATES: 'All templates',
  ALL_PRE_CONFIGURED_WORKFLOWS: 'All pre-configured workflows',
  ALL_STAMP_GROUPS: 'All stamp groups',
  ALL_STAMP_SERIES: 'All stamp series',
  API: 'API',
  ESIGN_AND_SEAL: 'eSignature & Seal',
  ESIGN_ID: 'eSign ID',
  ESIGN_NAME: 'eSign Name',
  ESIGN_PREVIEW: 'eSign Preview',
  STORAGE_TYPE: 'Storage Type',
  DRAW_SIGN: 'Draw Sign',
  CERTIFICATE_ID_URL: 'Certificate ID/URL',
  CERTIFICATE_ID: 'Certificate ID',
  ENTER_ESIGN_NAME: 'Enter eSign Name',
  PROFILE_ACCESS_URL: 'Profile Access URL',
  PROFILE_ACCESS_URL_PLACEHOLDER: 'Enter Profile Access URL',
  MY_SERVER: 'My Server',
  LEEGALITY_SERVER: 'Leegality Server',
  DOC_SIGNER_STORAGE_PLACEHOLDER: 'Where do you want to store the Document Signer Certificate?',
  DRAW_SIGN_TITLE: 'Draw Signature here',
  CHOOSE_SIGN: 'Choose Sign',
  UPLOAD_SIGN: 'Upload Sign',
  CAPTURE_SIGN_TITLE: 'Sign on a white paper and capture its picture',
  CAPTURE_SIGN_CTA: 'Click to capture',
  UPLOAD_SIGN_TITLE: 'Upload a picture of your signature',
  GUIDELINES: 'Guidelines',
  PHYSICAL_SIGN_GUIDELINE_1: 'Ensure that the lighting is appropriate and avoid shadows.',
  PHYSICAL_SIGN_GUIDELINE_2: 'Sign on a plain white paper and use blue/black ink for better quality.',
  NO_CAMERA_DETECTED: 'No Camera Detected',
  CAPTURE_SIGN_SCREEN_TITLE: 'Capture your signature',
  CROP_SCREEN_TITLE: 'Rotate & crop your signature',
  PHYSICAL_SIGN_SELECTION: 'Select the best signature match',
  ISSUE_PROMPT: 'Having trouble?',
  TRY_AGAIN: 'Try again',
  PURCHASE_HISTORY: 'Purchase History',
  INVOICES: 'Invoices',
  CONSUMPTION_HISTORY: 'Consumption History',
  BILLING_PROFILES: 'Billing Profiles',
  LOW_BALANCE_CONFIGS: 'Low Balance Configs',
  BRANDING: 'Branding',
  SECURITY: 'Security',
  ESIGNATURE: 'eSignature',
  STAMP: 'Stamp',
  DOCUMENT_CONFIGS: 'Document Configs',
  INVITEE_CONFIGS: 'Invitee Configs',
  NESL_ESIGN_CONFIG: 'NeSL eSign Config',
  NESL_VALIDATION: 'NeSL Validation',
  NESL_AADHAAR_VALIDATION: 'NeSL Aadhaar Validation',
  SFTP: 'SFTP',
  DEPARTMENTS: 'Departments',
  ORGANISATION: 'Organisation',
  MULTI_FACTOR_AUTH: 'Multi-factor Auth',
  MSG_VIEW_LOGS_DOCS_OF_OTHER_USERS_IN_ORG: 'View documents and logs of other users in the organisation',
  TO: 'To',
  HIDE: 'Hide',
  PROCESSING_INFO: 'If you are unable to find a document here, you may find it on the ‘Sent’ page.',
  EXPIRED_DOCUMENTS_DELETED_IN_30_DAYS: 'Documents that have been in the expired folder for 30 days will be automatically deleted.',
  ITEM: 'Item',
  NO_LATEST_ACTIVITY: 'No Latest Activity',
  TEN_THOUSAND_RECORDS_REFINE_FILTER_FOR_REPORT_GENERATION: 'The number of records is greater than 10,000. Please refine your filter/search criteria to enable report generation.',
  DOWNLOAD_AUDIT_TRAIL: 'Download Audit Trail',
  NA: 'NA',
  PLEASE_REFER_PACK_ID_BY_UNHIDING_COLUMN: 'Please refer Pack ID by unhiding the column',
  DATE_AND_TIME: 'Date & Time',
  BROWSER_CAPS: 'BROWSER',
  OS_CAPS: 'OS',
  IP_CAPS: 'IP',
  USING_SMALL: 'using',
  FOLDER_NAME: 'Folder Name',
  ENTER_FOLDER_NAME: 'Enter Folder Name',
  FOLDER_ID: 'Folder ID - {folderId}',
  STAMPS_SELECTED: '{count} stamps selected',
  CONTACTS_SELECTED: '{count} contacts selected',
  CONTACT_UPLOAD_FAILURE: '{count}/{total} contacts uploaded, check the report below for errors',
  POC_NAME: 'P.O.C. Name',
  POC_PHONE_NUMBER: 'P.O.C. Phone Number',
  ENTER_POC_PHONE_NUMBER: 'Enter P.O.C. Phone Number',
  ENTER_POC_NAME: 'Enter P.O.C. Name',
  BRACKET_OPTIONAL: '(Optional)',
  STAMP_DUTY_PAID_BY: 'Stamp Duty Paid By',
  REQUIRED_FIELD: 'This is a required field',
  CHARACTERS_LEFT: '{char} characters left',
  MAX_CHARACTERS_ALLOWED: 'Max {char} characters allowed',
  CREATE_STAMP_SERIES_SUCCESS: 'Stamp series created successfully',
  CAN_START_STAMP_PAPERS_FOR_SERIES_ORDER: 'You can now start order placement of stamp papers for this series.',
  EDIT_DRAFT: 'Edit Draft',
  ADDRESS_LINE_1: 'Address Line #1',
  ADDRESS_LINE_2: 'Address Line #2',
  ENTER_ADDRESS_LINE_1: 'Enter Address Line 1',
  ENTER_ADDRESS_LINE_2: 'Enter Address Line 2',
  DRAFT_DELETED_SUCCESSFULLY: 'Draft deleted successfully',
  DRAFT_CREATED_SUCCESSFULLY: 'Draft created successfully.',
  DRAFT_UPDATED_SUCCESSFULLY: 'Draft updated successfully.',
  ERROR: 'Error',
  AUTOSAVE_SIGNED_DOCUMENTS: 'Auto-Save Signed Documents',
  AUTOMATICALLY_SAVE_DOCUMENTS: 'Automatically save documents sent to you in your leegality account.',
  MSG_ENABLE_API: 'Enabling API allows you to make API calls for automating the document execution process.',
  ENABLE_API: 'Enable API',
  TOKEN_GENERATED_SUCCESS: 'Token generated successfully.',
  TOKEN_DELETED_SUCCESS: 'Token deleted successfully.',
  MSG_UNIQUE_IDENTIFIER_TO_VALIDATE_API_CALLS: 'Unique identifier which lets Leegality validate the API calls.',
  MSG_VERIFY_WEBHOOK_CALLS: 'Used to verify the webhook calls made by Leegality.',
  PRIVATE_SALT: 'Private Salt',
  AUTH_TOKEN: 'Auth Token',
  LEGACY_AUTH_TOKEN: 'Legacy Auth Token',
  WHITELISTED_IP: 'Whitelisted IPs',
  MSG_WHITELIST_IPS_FOR_API_CALL: 'Whitelist IPs that can make API calls to Leegality.',
  MANAGE_JWT_ACCESS: 'Manage JWT Access',
  MSG_MANAGE_CLIENT_ID_AND_SECRET: 'Required for newer APIs. Use this to create and manage Client ID/ Secret credentials.',
  IPV4_FORMAT: 'xxx . xxx . xxx . xxx',
  CONFIGURATION_SAVED_SUCCESSFULLY: 'Configuration saved successfully.',
  COPY_TO_CLIPBOARD: 'Copy to clipboard',
  COPY_LABEL_TO_CLIPBOARD: 'Copy {label} to clipboard',
  DOCUMENT_ACTIONS: 'Document actions',
  INVITEE_ACTIONS: 'Invitee actions',
  GROUP_ACTIONS: 'Group actions',
  REFRESH_TOKEN: 'Refresh Token',
  DISABLE_API: 'Disable API',
  DISABLE: 'Disable',
  MSG_ENTERED_IP_ALREADY_WHITELISTED: 'The entered IP address is already whiltelisted',
  MSG_SURE_TO_DISABLE_API: 'Are you sure you want to disable API? This will stop all API communication with this account.',
  ESIGNATURE_AND_SEAL: 'eSignature & Seal',
  DEFAULT_ESIGNATURE_SEAL: 'Default eSignature Seal',
  AUTHORISED_SIGNATORY: 'Authorised Signatory',
  DIRECTOR: 'Director',
  UPLOAD_SEAL: 'Upload Seal',
  VIRTUAL_SIGN: 'Virtual Sign',
  VIRTUAL_SIGN_SETUP: 'Virtual Sign Setup',
  QUICK_SIGN_SETUP: 'Quick Sign Setup',
  CLOUD_DSC_SETUP: 'Cloud DSC Setup',
  UPDATE_CLOUD_DSC: 'Update Signer ID',
  SIGNER_ID: 'Signer ID',
  ENTER_SIGNER_ID: 'Enter Signer ID',
  VALIDATE_AND_UPDATE: 'Validate & Update',
  I_KNOW_MY_SIGNER_ID: 'I know my Signer ID',
  FIND_MY_SIGNER_ID: 'Find my Signer ID',
  CHECK: 'Check',
  DONT_HAVE_YOUR_PAN: 'Don’t have your PAN?',
  DONT_HAVE_YOUR_MOBILE_NUMBER: 'Don’t have a mobile number?',
  FIND_USING_PAN: 'Find using PAN',
  FIND_USING_MOBILE_NUMBER: 'Find using mobile number',
  VIEW_MORE_IDS: 'View more IDs',
  VIEW_LESS_IDS: 'View less IDs',
  INDIAN_KYC: 'Indian',
  FOREIGN_KYC: 'Foreign',
  CHECKING_THESE_DETAILS: 'Checking these details…',
  SAVING_SIGNER_ID: 'Saving your Signer ID…',
  THIS_CAN_TAKE_A_FEW_SECONDS: 'This can take a few seconds. Please stay on this screen.',
  ONE_SIGNER_ID_FOUND_FOR: '1 Signer ID found for',
  COUNT_SIGNER_IDS_FOUND_FOR: '{count} Signer IDs found for',
  MSG_NO_SIGNER_IDS_FOUND: 'No Signer IDs found. Check the details and search again.',
  SIGNER_ID_OFFERED_AUTOMATICALLY_WHEN_SIGNING: 'This is offered automatically when you\'re asked to sign with Cloud DSC.',
  MSG_COULD_NOT_REACH_ESIGN_PROVIDER: 'We could not reach the eSign provider. Please try again.',
  MSG_SIGNER_ID_SAVED: 'Signer ID saved successfully.',
  MSG_SIGNER_ID_REMOVED: 'Signer ID removed successfully.',
  MSG_VAL_INTL_TEL_NUMBER: 'Please enter a valid mobile number for the selected country',
  DOC_SIGNER_SETUP: 'Document Signer Certificate Setup',
  DOCUMENT_SIGNER_CERTIFICATE: 'Document Signer Certificate',
  ORGANISATION_NAME: 'Organisation Name',
  SETUP: 'Setup',
  NONE: 'None',
  MSG_DEFAULT_SEAL_UPDATE_SUCCESS: 'Default eSignature seal updated successfully.',
  JPG_JPEG_PNG_PERMITTED_FILE_FORMAT: 'Permitted file format: PNG, JPEG and JPG',
  MSG_AUTHENTICATED_THROUGH_LEEGALITY: 'Authenticated through Leegality.com (3NC0XrH)',
  FOR: 'For',
  SERIES_DETAILS: 'Series Details',
  SHIPPING: 'Shipping',
  LEGEND: 'Legend',
  SERIES_AND_STAMP: 'Series & Stamp',
  SIGNATURE_AND_SEAL_PREVIEW: 'Signature & Seal Preview',
  SEND_REMINDERS_AND_NOTIFICATIONS: 'Send Invitation Reminders And Notifications',
  SEND_EMAIL_SMS: 'Send email/SMS/WhatsApp reminders and notifications to Invitees by default.',
  EXPIRES_AFTER_45: 'Expires after 45 minutes of sending',
  EXPIRES_AT_EOD: 'Expires at the end of day of sending',
  EXPIRES_AFTER_RANGE: 'Expires after the below configured number of days',
  ENTER_NO_OF_DAYS: 'The number of days can range from 1 to 365.',
  DISABLE_EXPIRY: 'Disable enforcement of document expiry',
  DOCUMENT_EXPIRY_BYDEFAULT: 'Document expiry can be set during the sending journey and will be 10 days by default.',
  ENTER_DAYS_PLACEHOLDER: 'Enter Days: 1-365',
  ENFORCE_INVITATION_EXPIRY: 'Enforce Invitation Expiry',
  ENTER_NO_OF_DAYS_DOC_COMPLETION: 'The number of days can range from 7 to 365.',
  ENTER_DAYS_PLACEHOLDER_DOC_COMPLETION: '7-365 days',
  ENFORCE_1FA: 'Enforce 1-Factor Authentication',
  ENFORCE_1FA_DESCRIPTION: 'OTP verification before document preview will be mandatory.',
  ENFORCE_2FA: 'Enforce 2-Factor Authentication',
  ENFORCE_2FA_DESCRIPTION: 'OTP verification via alternate contact before document preview will be mandatory.',
  ENFORCE_2FA_TOOLTIP_TITLE: 'Both email ID and phone number will be required.',
  ENFORCE_2FA_TOOLTIP_DESCRIPTION: 'e.g. If the user opens the signing journey via the notification sent on their phone the verification OTP will be sent to their email ID (alternate contact).',
  ENFORCE_RAW_DOC_URL: 'Enforce Raw Document URL with OTP Verification Message',
  ENFORCE_RAW_DOC_URL_DESCRIPTION: 'URL containing document PDF will be sent in all verification OTP notifications.',
  ENFORCE_AUTO_DOC_DELETE_COMPLETION: 'Enforce auto-delete after Document Completion',
  ENFORCE_AUTO_DOC_DELETE_COMPLETION_DESCRIPTION: 'Documents will be deleted after configured days of completion.',
  MORE_INFO: 'More Info',
  ENTER_AN_ALTERNATIVE_EMAIL: 'Configure and enforce invitation expiry on all documents for this account.',
  DOCUMENTS_SETTINGS_UPDATED_SUCCESSFULLY: 'Documents Settings Updated Successfully',
  SERIES_DELETED_SUCCESSFULLY: 'Series Deleted Successfully',
  NO_STARRED_RECORDS_FOUND: 'No Starred Records Found',
  SELF_UPLOADED_STAMPS: 'Self Uploaded Stamps',
  EXAMPLE_QUANTITY: 'e.g. 300',
  STAMP_PAPER_PREVIEW: 'Stamp Paper Preview',
  STAMP_SERIES: 'Stamp Series',
  STAMP_GROUP: 'Stamp Group',
  CONTACT: 'Contact',
  PURCHASE_ORDER: 'Purchase Order',
  MENU: 'Menu',
  ZERO_TO_THREE_SIXTY_FIVE_DAYS: '0-365 days',
  N_GROUPS_SELECTED: '{count} Groups selected',
  MSG_EXTENDED_STAMP_EXPIRY_REMAIN_EXPIRED: 'At least some stamps will continue to remain expired as the extended expiry date falls before today.',
  GENERATE_PDF: 'Generate PDF',
  SAVE_AND_FINISH: 'Save and Finish',
  PREVIEW_PDF: 'Preview',
  NAME_OF_FIELD: 'Name of Field',
  LIST_OF_OPTIONS: 'List Of Options',
  NAME_OF_DOCUMENT_PLACEHOLDER: 'Document Name',
  MAX_FILE_SIZE: 'Max File Size',
  REPLACE_BASE_PDF: 'Replace Base PDF',
  THIS_WILL_REPLACE_PDF_FOR_THIS_TEMPLATE: 'This will replace the existing PDF for this template.',

  BRAND_NAME: 'Brand Name',
  VISIBLE_AS_SENDER_NAME: 'Visible as sender name in all invitee communication.',
  BRAND_COLOUR: 'Brand Colour',
  BRAND_COLOUR_DESCRIPTION: 'Enter value in "#ffffff" format(Hex Code)',
  ADD_THE_SELECTED_COLOUR: 'Adds the selected colour to the email and signing journey.',
  BRAND_LOGO: 'Brand Logo',
  LOGO_DESCRIPTION: ' Supported formats: JPEG, JPG and PNG (Max - 2MB)',
  REPLACES_LEEGALITY_LOGO: 'Replace Leegality logo in emails and signing journey. Recommended size: 250×100 px.',
  CORNER_RADIUS: 'Corner Radius (V4)',
  BUTTON_AND_CARD_ROUNDNESS: 'Sets roundness of buttons, cards, input fields, checkboxes, etc. Sharp: 0px; Round: 16px; Default: 8px',
  ENTER_CORNER_RADIUS: 'Enter corner radius',
  DEPARTMENT_BRANDING: 'Branding',
  BRANDING_PROFILE: 'Branding Profile',
  PROFILE_SETTINGS: 'Profile Settings',
  BRANDING_SETTINGS_PREVIEW: 'Brand settings preview',
  BRANDING_PREVIEW: 'Branding Preview',
  EMAIL_PREVIEW: 'Email Preview',
  SIGNING_JOURNEY_DOCUMENT_PREVIEW: 'Signing Journey - Document Preview',
  SIGNING_JOURNEY_AADHAAR_SIGNING: 'Signing Journey - Aadhaar Signing',
  WEB: 'Web',
  MOBILE: 'Mobile',
  VERIFY_OTP: 'Verify OTP',
  MSG_INVALID_HEX_CODE: 'Invalid Hex Code',
  BRANDING_PROFILE_UPDATED_SUCCESSFULLY: 'Branding profile updated successfully.',
  FILE_GREATER_THAN_9MB: 'File size exceeds maximum limit of 9 MB.',
  FAILED_TO_LOAD_IMAGE: 'Failed to load the image.',
  VENDOR: 'Vendor',
  CONTACT_ORG_ADMIN_OR_BILLING_USER_FOR_STAMP_PURCHASE: 'Contact an organisation admin or billing user to initiate a stamp purchase.',
  MSG_NOTE_THIS_CANNOT_BE_CHANGED_LATER: 'Note: This cannot be changed later',
  START_BY_SELECTING_STATE: 'Start by selecting a state',
  SELECTED_STATE_SERIES_WILL_APPEAR_HERE: 'All the series for the selected state will appear here',
  SELECT_STATE_TO_ENABLE_THIS_FIELD: 'Select state to enable this field',
  SELECT_SERIES_TO_ADD_TO_THIS_GROUP: 'Select the series you want to add to this group',
  MAXIMUM_VALUE_ALLOWED: 'Maximum value allowed: {amount}',
  ADD_ATLEAST_N_SERIES_TO_THE_GROUP: 'Please add at least {count} series to the group',
  ATTACHED_STAMP_PAPERS: 'Attached Stamp Papers',
  CHANGE_PASSWORD: 'Change Password',
  MULTI_FACTOR_AUTHENTICATION_DESCRIPTION: 'Add an extra layer of security to your organisation’s  Leegality accounts by requiring an additional code from an authenticator app to log in.',
  SETUP_MFA_BUTTON: 'Set Up Multi-Factor Authentication',
  MFA_BANNER_TEXT: 'Multi-Factor Authentication cannot be configured on mobile devices.',
  TEST_ENVIRONMENT: 'Test Environment',
  CHANGE_PASSWORD_VIA_CURRENT_PASSWORD_OR_RESET_CODE: 'Change your password using your current password or a reset code',
  ADD_SERIES: 'Add Series',
  SAVE_AND_PROCEED: 'Save & Proceed',
  X_REMAINING_N_CONSUMED: '{remain} Remaining ({consumed}% Consumed)',
  N_PAPERS: '{count} papers',
  THIS_IS_REQUIRED_FIELD: 'This is a required field.',
  AUTHORISED_SIGNATORY_SEAL: 'Authorised Signatory Seal',
  DIRECTOR_SEAL: 'Director Seal',
  SIGNATURE_PREVIEW: 'Signature Preview',
  RESET_CODE: 'Reset Code',
  CHANGE_PASSWORD_VIA_CURRENT_PASSWORD: 'Change Via Current Password',
  CHANGE_PASSWORD_VIA_RESET_CODE: 'Change Via Reset Code',
  DIDNT_RECEIVE_OTP: 'Didn’t receive the OTP? ',
  ALL_REJECTED_INVITATIONS_BY_SIGNER_OR_REVIEWER: 'All invitations that have been rejected by a signer or reviewer',
  MSG_VAL_IPV4: 'Please enter a valid IPv4 address.',
  MSG_VAL_GST: 'Please enter a valid GST number.',
  MSG_VAL_PAN: 'Please enter a valid PAN.',
  ENABLE_MFA: 'Enable MFA',
  DOWNLOAD_AUTH_APP: 'Download an authenticator app',
  STEP1: 'Step 1:',
  DOWNLOAD_THIRD_PARTY_AUTH_APPLICATION: 'Download a Third Party Authenticator application like',
  GOOGLE_AUTHENTICATOR: 'Google Authenticator',
  ON_YOUR_MOBILE: 'on your mobile.',
  LIST_OF_SUPPORTED_APPS: 'Find a list of supported apps',
  HERE: 'here',
  SCAN_QR_CODE: 'Scan the QR code',
  STEP2: 'Step 2:',
  SCAN_QR_CODE_DESCRIPTION: 'Scan the QR Code using the third party app you’ve downloaded on your mobile phone.',
  VERIFY_YOUR_CODE: 'Verify your code',
  STEP3: 'Step 3:',
  VERIFY_YOUR_CODE_DESCRIPTION: 'Enter the OTP shown in the Authenticator app for Leegality (email@organisation.com)',
  QR_CODE: 'QR Code',
  DISABLE_MFA: 'Disable Multi-Factor Authentication',
  MFA: 'Multi-Factor Authentication',
  DISABLE_MFA_BUTTON: 'Disable MFA',
  NO_FOLDER_FOUND: 'No folders found',
  SELECTED: 'selected',
  SUBSCRIPTION_SUCCESSFUL: 'Subscription Successful',
  MSG_HELPER_SUBSCRIBED_TO_NOTIFICATION_CATEGORY: 'Subscribed to notification category successfully.',
  MSG_TEXT_UNSUBSCRIBED_FROM_NOTIFICATION_CATEGORY: 'Subscription Removal Successful',
  MSG_HELPER_UNSUBSCRIBED_FROM_NOTIFICATION_CATEGORY: 'Unsubscribed from notification category successfully.',
  NOTIFICATION_SETTINGS_TAB_TITLE_FOR_USER: 'User Level Notifications',
  NOTIFICATION_SETTINGS_TAB_DESC_FOR_USER: 'Configure notifications and recipients for events concerning your personal Leegality account.',
  NOTIFICATION_SETTINGS_TAB_TITLE_FOR_ORGANISATION: 'Organisation Level Notifications',
  NOTIFICATION_SETTINGS_TAB_DESC_FOR_ORGANISATION: 'Configure notifications and recipients for events concerning your Leegality organisation.',
  ADD_RECIPIENT: 'Add Recipient',
  X_OF_Y_CONFIGURED: '{x}/{y} configured',
  RECIPIENTS: 'Recipients',
  MANAGE_RECIPIENTS: 'Manage Recipients',
  CREATE_RECIPIENT: 'Create Recipient',
  EDIT_RECIPIENT: 'Edit Recipient',
  PASSWORD_DOESNOT_MEET_REQUIRED_SPECIFICATIONS: 'Password does not meet required specifications.',
  NUMBER_OF_RECORD_GREATER_THAN_LIMIT: 'The number of records is greater than {limit}. Please refine your filter/search criteria to enable report generation.',
  STAMP_SETTINGS: 'Stamp Settings',
  ENABLE_AND_CONFIGURE_OPTIONS: 'Enable and configure options under the Bharat Stamp stack to facilitate stamp duty payment via Leegality.',
  STAMP_ACCESS: 'Stamp Access',
  ALLOW_STAMP_ACCESS_FOR_ORGANISATION: 'Allows stamp access for your organisation.',
  SELF_UPLOAD_STAMP: 'Self-Upload Stamp',
  ALLOWS_SELF_UPLOAD_STAMP_FOR_DOCUMENTS: 'Allows self-uploaded stamps to be configured for a document.',
  REVENUE_STAMP: 'Revenue Stamp',
  ALLOW_REVENUE_STAMP_ACCESS_FOR_ORGANISATION: 'Allows revenue stamp series access for your organisation.',
  ALLOWS_ADMIN_TO_CREATE_STAMP_SERIES: 'Allows admins to create stamp series which can be used to place stamp paper orders and attach stamp papers to documents.',
  ALLOWS_ADMIN_TO_CREATE_MULTIPLE_STAMP_SERIES: 'Allows users to select & attach stamp papers from multiple series to a single document.',
  ALLOWS_ADMIN_TO_CREATE_STAMP_GROUP: 'Allows admins to create stamp groups which facilitate variable stamp duty payment by combining different stamp series.',
  PROFILE_ID: 'Profile ID',
  SERVICE_NAME: 'Service Name',
  NESL_API_KEY_ALPHA_NUMERIC: 'NeSL API Key (Alpha Numeric)',
  CLIENT_ID: 'Client ID',
  ENCRYPTION_KEY_ID: 'Encryption Key ID',
  NESL_EXPIRY_TIMELINE_SECONDS: 'NeSL Expiry Timeline (seconds)',
  INVITEE_CONFIGURATIONS: 'Invitee Configurations',
  ENABLE_AND_CONFIGURE_VARIOUS_INVITEE_OPTIONS: 'Enable and configure various invitee options to allow an enhanced document execution experience.',
  REVIEWER_ROLE: 'Reviewer Role',
  ALLOWS_REVIEWERS_TO_BE_CONFIGURED_FOR_DOCUMENTS: 'Allows reviewers to be configured for documents.',
  GROUPS_INVITEES: 'Groups Invitees',
  ALLOWS_INVITEES_TO_BE_ADDED_INTO_A_GROUP: 'Allows invitees to be added into a group.',
  CC_NOTIFICATIONS: 'CC Notifications',
  ALLOWS_CC_TO_BE_ADDED_TO_A_DOCUMENT: 'Allows CC’s to be added to a document.',
  COORDINATE_PICKER: 'Coordinate Picker',
  ALLOWS_A_COORDINATE_PICKER_TO_BE_ASSIGNED_FOR_A_DOCUMENT: 'Allows a coordinate picker to be assigned for a document.',
  GPS_LOCATION_AND_ACCURACY_BASED_RESTRICTIONS_IN_THE_SIGNING_JOURNEY: 'GPS location and accuracy based restrictions in the signing journey',
  CONFIGURE_PERMISSIBLE_RADIUS_AND_ALLOWED_DEVIATION_FOR_GPS_BASED_RESTRICTIONS: 'Configure permissible radius and allowed deviation for GPS based restrictions.',
  REJECTION_IN_SIGNING_JOURNEYS: 'Rejection in Signing Journeys',
  ALLOWS_SIGNERS_TO_REJECT_A_DOCUMENT: 'Allows signers to reject a document.',
  ALLOWS_CONTACT_BOOK_ACCESS_TO_ALL_USERS_IN_YOUR_ORGANISATION: 'Allows contact book access to all user’s in your organisation.',
  LOCAL_LANGUAGE_SUPPORT: 'Local Language Support',
  ALLOWS_LOCAL_LANGUAGE_SUPPORT_TO_BE_CONFIGURED_IN_THE_SIGNING_JOURNEY: 'Allows local language support to be configured in the signing journey.',
  WHATSAPP_PINGS: 'WhatsApp Pings',
  ALLOWS_WHATSAPP_NOTIFICATIONS_TO_BE_CONFIGURED_FOR_YOUR_DOCUMENTS: 'Allows WhatsApp notifications to be configured for your documents.',
  ALLOWS_PII_MASKING_FOR_INVITEE_DATA_AND_ETC: 'Allows PII masking of invitee data in the Audit Trail, Details page and Signing Journey etc.',
  AUTO_CHECK_CONSENT: 'Auto Check Consent',
  ALLOWS_CONSENT_CHECKBOX_TO_BE_PRE_TICKED: 'Allows the consent checkbox to be pre-ticked on the invitee\'s screen. Not applicable to ESP consents.',
  FACE_MATCH_VERIFICATION: 'Face Match Verification',
  CONFIGURE_ACCEPTANCE_PERCENTAGE_AND_SUBSEQUENT_FAILURE_TREATMENT: 'Configure acceptance percentage & subsequent failure treatment for face match.',
  CONFIGURE_ACCEPTANCE_FOR_SMART_USER_LIVELINESS: 'Configure acceptance for Smart User Liveliness.',
  DEFAULT_PERMISSIBLE_RADIUS: 'Default Permissible Radius (In Meters)',
  DEFAULT_ALLOWED_ACCURACY_DEVIATION: 'Default Allowed Accuracy Deviation (In Meters)',
  ACCEPTANCE_PERCENTAGE: 'Acceptance Percentage',
  FAILURE_TREATMENT: 'Failure Treatment',
  ACCEPTANCE_PLACEHOLDER: '1-100',
  REJECT_IF_FAILED: 'Reject if Failed',
  ESIGNATURE_SETTINGS: 'eSignature Settings',
  ENABLE_CONFIGURE_ESIGN_TYPES_FOR_ORG: 'Enable and configure various eSign types that can be applied to documents for your organisation.',
  BIOMETRIC: 'Biometric',
  IRIS: 'IRIS',
  UPLOAD_OR_CAPTURE: 'Upload/Capture',
  CAPTURE: 'Capture',
  FINGERPRINT: 'Fingerprint',
  DRAW: 'Draw',
  AUTOMATED_SIGN: 'Automated Sign',
  AUTOMATED_SIGN_VIRTUAL_CONSENT:
    'By clicking this checkbox and selecting Save, I agree that the Virtual Signature saved in this Account will be the electronic representation of my signature for all the electronic documents that are authenticated by use of Unique ID and Passkey as configured by me. \nI also understand that recipients of such electronic documents will be able to see my signing details, including my Email ID/Phone Number and IP address.',
  AUTOMATED_SIGN_VISUAL_CONSENT:
    'By clicking this checkbox and selecting Save, I agree that the Visual Signature saved in this Account will be the electronic representation of my signature for all the electronic documents that are authenticated by use of Unique ID and Passkey as configured by me. \nI also understand that recipients of such electronic documents will be able to see my signing details, including my Email ID/Phone Number and IP address.',
  AUTOMATED_SIGN_DOC_CONSENT:
    'By clicking this checkbox and selecting Save, I agree that the Document Signer Certificate saved in this Account will be used to eSign documents for me, when enabled by the Unique ID and Passkey configured by me. I also understand that recipients of such electronic documents will be able to see my signing details.',
  NESL_ESIGN: 'NeSL eSign',
  SIGNATURE_CONFIG_UPDATED_SUCCESSFULLY: 'Signature config updated successfully.',
  DEFAULT: 'Default',
  SET_AS_DEFAULT: 'Set As Default',
  DEFAULT_ESIGN_TYPE_CANNOT_BE_DISABLED: 'Default eSign type cannot be disabled.',
  VERIFICATION_SETTINGS: 'Verification Settings',
  VERIFICATION_TYPE: 'Verification Type',
  ACCEPTANCE_CONDITION: 'Acceptance Condition',
  RESET_TO_DEFAULT: 'Reset to Default',
  SEND_LEEGALITY_SIGNING_LINK_FOR_FIRST_INVITEE: 'Send Leegality signing link for first invitee',
  MAKE_LEEGALITY_SIGNING_LINK_MANDATORY_FOR_FIRST_INVITEE: 'Make Leegality signing link mandatory for first invitee',
  LAST_FOUR_DIGITS_OF_AADHAAR_NO: 'Last 4 digits of Aadhaar No.',
  ACCEPT_BUT_RESPOND_WITH_RESULT: 'Accept but respond with result',
  FIRST_INVITEE_OF_NESL_DOC_WILL_RECEIVE_SIGNING_LINK: 'First invitee of any NeSL document created by your organisation will mandatorily receive the Leegality signing link',
  YEAR_OF_BIRTH: 'Year of Birth',
  TITLE: 'Title',
  PARAMETERS: 'Parameters',
  ACCURACY_PERCENTAGE: 'Accuracy %',
  LEEGALITY_VERIFICATION: 'Leegality Verification',
  AADHAAR_VERIFICATION: 'Aadhaar Verification',
  DSC_VERIFICATION: 'DSC Verification',
  NESL_VERIFICATION: 'NeSL Verification',
  SMART_NAME_VERIFICATION: 'Smart Name Verification',
  AI_BASED_NAME_MATCHING: 'AI-Based name matching',
  TEXT_BASED_NAME_MATCHING: 'Text-Based name matching',
  MATCH_THRESHOLD: 'Match Threshold',
  AADHAAR_ESIGN_VERIFICATION_SETTINGS: 'Aadhaar eSign Verification Settings',
  TEXT_STYLES_SETTINGS: 'Text Styles Settings',
  SELECT_TYPE_OF_TEXT_STYLE_AVAILABLE_TO_SIGNER: 'Select the type of text styles available to the signer.',
  DSC_VERIFICATION_SETTINGS: 'DSC Verification Settings',
  CLOUD_DSC_VERIFICATION_SETTINGS: 'Cloud DSC Verification Settings',
  ENABLE_FOREIGNER_ESIGN_FLOW: 'Enable Foreigner eSign Flow',
  SENDERS_CAN_CHOOSE_FOREIGNER_SIGN_FLOW_FOR_AN_INVITEE: 'Senders can choose the Foreigner Sign flow for an invitee. These signatures are charged to your Cloud DSC (Foreigner Sign) credits.',
  NESL_ESIGN_SETTINGS: 'NeSL eSign Settings',
  PLEASE_ENABLE_ONE_ATLEAST_ONE_NAME: 'Please enable atleast one {name} style.',
  STAY_HERE: 'Stay Here',
  ACCEPT_WITH_RESULT: 'Accept with Result',
  ACCEPT_BUT_PAUSE_SIGNING_JOURNEY: 'Accept but pause signing journey',
  CONFIGURE_NAME_MATCH_THRESHOLD_AND_ACTIONS_IN_FAILURE: 'Configure the name match threshold and subsequent actions in case of failure',
  ESIGN: 'eSign',
  PURCHASE_AMOUNT_WITH_RUPEE: 'Purchase Amt. (₹)',
  PURCHASE_VALUE_WITH_RUPEE: 'Purchase Value (₹)',
  CONSUMED_WITH_RUPEE: 'Consumed (₹)',
  EXPIRED_WITH_RUPEE: 'Expired (₹)',
  BALANCE_WITH_RUPEE: 'Balance (₹)',
  PURCHASE_QUANTITY: 'Purchase Qty. (₹)',
  UNDER_PROCESS: 'Under Process',
  UNUSED_CREDITS: 'Unused Credits',
  RESERVED_CREDITS: 'Reserved Credits',
  COMPLETED_OR_EXPIRED: 'Completed/Expired',
  NO_PURCHASES_FOR_THIS_ACCOUNT: 'You have not made any stamp paper purchases for this account.',
  CLICK_BELOW_BUTTON_TO_INITIATE_PURCHASE: 'Click the below button to initiate a purchase',
  NO_ACTIVE_PURCHASE_ORDERS: 'No active purchase orders',
  NO_COMPLETED_OR_EXPIRED_PURCHASE_ORDER_FOUND: 'No completed/expired purchase orders found',
  CONFIGURE_NESL_SIGNING_LINK_CONDITIONS_AND_FAILURE_ACTIONS: 'Configure NeSL signing link conditions and subsequent actions upon failure of certificate parameter certification',
  CONFIGURE_ACTIONS_UPON_FAILURE_OF_CERTIFICATE_PARAMETER_CERTIFICATION: 'Configure subsequent actions upon failure of certificate parameter verification',
  MSG_ADD_NEW_SFTP_PROFILE: 'Add a new SFTP profile to enable seamless document transfer to your database.',
  NO_SFTP_PROFILES_FOUND: 'No SFTP profiles found',
  ADD_NEW_SFTP: 'Add New SFTP',
  HOST_URL: 'Host URL',
  DESTINATION: 'Destination',
  PORT: 'Port',
  ENTER_PORT: 'Enter Port',
  TEST_CONNECTION: 'Test Connection',
  ENABLE_SFTP_IN_SENDING_JOURNEY: 'Allow SFTP in document sending journey',
  DELETE_SFTP_PROFILE: 'Delete SFTP Profile',
  MSG_DELETE_SFTP_PROFILE: 'Are you sure you want to this SFTP profile? Transfer of completed documents which have this SFTP Profile configured will fail.',
  Add_NEW_SFTP: 'Add New SFTP',
  PROFILE_NAME: 'Profile Name',
  ENTER_PROFILE_NAME: 'Enter Profile Name',
  ENTER_BRAND_NAME: 'Enter Brand Name',
  ENTER_BRAND_COLOR_NAME: 'Enter Brand Colour Name',
  ENTER_BRAND_COLOR_CODE: 'Enter Brand Colour Code',
  EDIT_PROFILE_NAME: 'Edit Profile Name',
  SFTP_PROFILE_NAME: 'SFTP Profile Name',
  ENTER_SFTP_PROFILE_NAME: 'Enter SFTP Profile Name',
  ENTER_SFTP_USERNAME: 'Enter SFTP Username',
  ENTER_SFTP_PASSWORD: 'Enter SFTP Password',
  MSG_ADD_SLASH_AFTER_DESTINATION: 'Note: Please add forward slash (/) after entering the destination',
  EDIT_SFTP: 'Edit SFTP',
  MSG_UPDATED_SFTP_CONFIG: 'SFTP config updated successfully.',
  PLACEhOLDER_SFTP_HOST_URL: 'sftp://example.com',
  PLACEHOLDER_SFTP_DESTINATION: './upload/leegality/documentID_sign/',
  SFTP_ID: 'SFTP ID',
  GPS_INPUT_PLACEHOLDER: '0-99999',
  DOCUMENT_CONFIGURATIONS: 'Document Configurations',
  ENFORCE_PDF_FLATTENING: 'Enforce PDF Flattening',
  ENFORCE_CONVERSION_OF_EDITABLE_PDFS_INTO_NON_EDITABLE_PDFS: 'Enforce conversion of editable pdf’s into non-editable pdf’s for all documents.',
  AUTO_DELETION_OF_DRAFT_DOCUMENTS: 'Enforce auto-deletion of draft documents',
  CONFIGURE_DAYS_AFTER_WHICH_DRAFT_DOCUMENTS_WILL_BE_DELETED: 'Configure number of days after which drafts documents will be deleted.',
  THIRTY_DAYS: '30 days',
  SERVICE: 'Service',
  NO_NESL_PROFILES_FOUND: 'No NeSL Profiles found',
  MSG_IF_UNEXPECTED_CONTACT_SUPPORT: 'If this is unexpected, please get in touch with our support team.',
  LINK_ORG_SFTP_FOR_SEAMLESS_FLOW_OF_DOC: 'Link your organisation’s SFTP with Leegality for seamless flow of documents.',
  CONFIGURE_COLUMNS: 'Configure Columns',
  SCROLL_TO_RIGHT: 'Scroll to right',
  SCROLL_TO_LEFT: 'Scroll to left',
  PAYMENT_COLLECT: 'Payment Collect',
  WORKFLOW_BUILDER_CONFIG: 'Workflow Builder Config',
  WORKFLOW_BUILDER_CONFIG_PAGE_TITLE: 'Workflow Builder Config',
  WORKFLOW_BUILDER_CONFIG_PAGE_SUBTITLE: 'Control which workflow-builder features your workflow creators can use.',
  WORKFLOW_BUILDER_PACK_MULTI_DOC: 'Multiple documents per pack',
  WORKFLOW_BUILDER_PACK_MULTI_DOC_HINT: 'Allow workflow creators to add more than one document to a single pack.',
  WORKFLOW_BUILDER_RULE_ENGINE: 'Rule Engine',
  WORKFLOW_BUILDER_RULE_ENGINE_HINT: 'Allow workflow creators to add and execute rules on workflows.',
  WORKFLOW_BUILDER_CUSTOM_FIELDS: 'Custom fields',
  WORKFLOW_BUILDER_CUSTOM_FIELDS_HINT: 'Allow workflow creators to define and use custom fields (lecf_*) in workflows.',
  WORKFLOW_BUILDER_CUSTOM_VALIDATIONS: 'Custom validations',
  WORKFLOW_BUILDER_CUSTOM_VALIDATIONS_HINT: 'Allow workflow creators to set UI-driven and regex validations on workflow fields.',
  WORKFLOW_BUILDER_CUSTOM_SENDING_UI: 'Page visibility & field reorder',
  WORKFLOW_BUILDER_CUSTOM_SENDING_UI_HINT: 'Allow workflow creators to hide pages in the workflow-runner UI and reorder fields.',
  WORKFLOW_BUILDER_CUSTOM_FIELD_PAGE: 'Custom page',
  WORKFLOW_BUILDER_CUSTOM_FIELD_PAGE_HINT: 'Allow workflow creators to create custom pages using custom fields.',
  LINK_ORG_PAYMENT_GATEWAY_ACC_TO_ENABLE_PAYMENT_COLLECTION: 'Link your organisation’s payment gateway account to Leegality  and enable payment collection in the signing journey.',
  MERCHANT_ID: 'Merchant ID',
  LINK_TO_FETCH: 'Link to fetch',
  AUTHORISED: 'Authorised',
  LINK_DESIRED_PAYMENT_GATE: 'Link your desired payment gateway',
  PAYMENT_COLLECTION_IN_SIGNING_REVIEW_JOURNEY: 'Payment Collection in signing/reviewer journey',
  LINK_ACCOUNT: 'Link Account',
  UNLINK_ACCOUNT: 'Unlink Account',
  BALANCE_TYPE: 'Balance Type',
  TRANSACTION_TYPE: 'Transaction Type',
  DEBIT_WITH_RUPEE: 'Debit (₹)',
  CREDIT_WITH_RUPEE: 'Credit (₹)',
  REFERENCE_ID: 'Reference ID',
  RELEASE_DATE: 'Release Date',
  SUBSCRIPTION_BALANCE: 'Subscription Balance',
  DEBIT: 'Debit',
  CREDIT: 'Credit',
  RESERVE: 'Reserve',
  RELEASE: 'Release',
  REDUCE: 'Reduce',
  CREDITS_AND_SUBSCRIPTION: 'Credits & Subscription',
  NO_ESIGN_AND_SUBSCRIPTIONS_PURCHASES_FOR_THIS_ACCOUNT: 'You have not made any eSign or subscription purchases for this account.',
  MAKE_YOUR_FIRST_PURCHASE_FOR_N_SERIES: 'Make your first purchase for Series: {series}',
  NO_PURCHASES_FOR_THIS_SERIES: 'You have not made any stamp paper purchases for this series.',
  MSG_NOTIFICATION_CONTACT_SAVED: 'Notification contact saved successfully.',
  MSG_NOTIFICATION_CONTACT_DELETED: 'Notification contact deleted successfully.',
  NAME_IS_REQUIRED: 'Name is required',
  EMAIL_OR_PHONE_REQUIRED: 'Email or Phone Number is required',
  INVALID_EMAIL_ADDRESS: 'Invalid Email Address',
  INVALID_PHONE_NUMBER: 'Invalid Phone Number',
  DUPLICATE_EMAIL: 'Duplicate Email',
  DUPLICATE_PHONE_NUMBER: 'Duplicate Phone Number',
  CONFIG_AND_MANAGE_ORG_BILLING_PROFILES: 'Configure and manage your organisations billing profile(s).',
  ID_UPPERCASE: 'ID',
  FILE_NAME: 'File Name',
  INVITATION_REPORT: 'Invitation Report',
  CREATE_BILLING_PROFILE: 'Create Billing Profile',
  COMPANY_NAME: 'Company Name',
  ENTER_COMPANY_NAME: 'Enter Company Name',
  BILLING_ADDRESS_LINE_1: 'Billing Address Line #1',
  BILLING_ADDRESS_LINE_2: 'Billing Address Line #2',
  ENTER_BILLING_ADDRESS: 'Enter Billing Address',
  ENTER_BILLING_ADDRESS_ADDITIONAL_DETAILS: 'Enter Billing Address (Additional Details)',
  CITY: 'City',
  ENTER_CITY: 'Enter City',
  COUNTRY: 'Country',
  GST: 'GST',
  ENTER_GST_NUMBER: 'Enter GST Number',
  EDIT_BILLING_PROFILE: 'Edit Billing Profile',
  ADD_NEW_BILLING_PROFILE: 'Add New Billing Profile',
  DELETE_BILLING_PROFILE: 'Delete billing profile',
  SURE_TO_DELETE_THIS_BILLING_PROFILE_ACTION_CANT_BE_UNDONE: 'Are you sure you want to delete this billing profile? This action cannot be undone.',
  DOWNLOAD_CONSUMPTION_REPORT: 'Download Consumption Report',
  NON_LENDING: 'Non Lending',
  LENDING: 'Lending',
  EBG: 'eBG',
  CREATED_SFTP_PROFILE_SUCCESSFULLY: 'SFTP Profile created successfully.',
  EDITED_SFTP_PROFILE_SUCCESSFULLY: 'SFTP profile updated successfully.',
  DELETED_SFTP_PROFILE_SUCCESSFULLY: 'SFTP Profile deleted successfully.',
  TESTING_CONNECTION: 'Testing connection',
  CONNECTION_TESTING_SUCCESSFUL: 'SFTP Profile connection established successfully',
  SFTP_CONNECTION_TESTING_FAILED: 'SFTP Profile connection error',
  AUTHENTICATION_METHOD: 'Authentication Method',
  PUBLIC_KEY: 'Public Key',
  REGENERATE_KEY_PAIR: 'Regenerate Key Pair',
  PUBLIC_KEY_LABEL: 'Public Key — share this with your SFTP server administrator',
  PUBLIC_KEY_COPIED: 'Public key copied',
  KEY_PAIR_REGENERATED_SUCCESSFULLY: 'Key pair regenerated successfully',
  MSG_REGENERATE_KEY_PAIR_WARNING: 'Regenerating will invalidate your existing key pair immediately. Document transfers will fail until your SFTP server administrator installs the new public key on their server. Continue?',
  SEARCH_SFTP_PROFILES: 'Search by profile name...',
  MSG_UNSAVED_CHANGES_WILL_BE_LOST: 'Are you sure you want to leave this page? All updates will be lost',
  PAYMENT_COLECT_ACTIVE_IN_SIGNER_REVIEW_JOURNEY: 'Payment Collection is currently active in signing/reviewer journey.',
  PAYMENT_COLECT_INACTIVE_IN_SIGNER_REVIEW_JOURNEY: 'Payment Collection is currently inactive in signing/reviewer journey.',
  NO_STAMPS_ADDED_FOR_N_SERIES: 'No stamps have been added to Series {series}',
  UNLINK_PAYMENT_GATEWAY: 'Unlink Payment Gateway',
  MSG_UNLINK_PAYMENT_GATEWAY: 'Are you sure you want to unlink this payment gateway? You will not be able to use it for payment collection from signers/reviewers.',
  DISABLE_PAYMENT_COLLECT: 'Disable Payment Collect',
  MSG_DISABLE_PAYMENT_COLLECT: 'Are you sure you want to disable payment collect? You will not be able to collect payments from signers/reviewers anymore.',
  REPOSITORY_OF_ALL_TAX_BILL_AND_PROFORMA_INVOICES: 'Repository of all your Tax Invoices, Bill of Supplies & Proforma Invoices',
  TAX_INVOICES_AND_BOS: 'Tax Invoices & B.O.S.',
  PROFORMA_INVOICES: 'Proforma Invoices',
  INVOICE_NUMBER: 'Invoice Number',
  NO_INVOICES_FOUND: 'No Invoices found',
  START_BY_CREATING_PURCHASE_REQUEST: 'Start by creating a purchase request',
  CREATE_PURCHASE_REQUEST: 'Create Purchase Request',
  CONFIGURE_ITEMS: 'Configure Items',
  CONFIRM_ORDER: 'Confirm Order',
  PAYMENT: 'Payment',
  NO_BILLING_PROFILE_FOUND: 'No Billing Profile Found',
  CREATE_BILLING_PROFILE_FOR_PURCHASE: 'You need to create a billing profile in order to purchase items for your Leegality account.',
  AT_THE_RATE_WITH_PRICE: '@ ₹{price}',
  TRANSACTIONAL_ITEMS: 'Transactional Items',
  BILLING_PROFILE: 'Billing Profile',
  SWITCH_PROFILE: 'Switch Profile',
  EDIT_PROFILE: 'Edit Profile',
  LAST_PURCHASE: 'Last Purchase',
  NO_PRIOR_PURCHASES_FOUND_FOR_THIS_ACCOUNT: 'You have not made any prior purchases for this Leegality account.',
  REPEAT: 'Repeat',
  ITEMS: 'Items',
  CONVENIENCE_FEE_FOR_STAMP_GST_TDS_WILL_BE_ADDED_ON_NEXT_PAGE: 'Convenience fee for stamp papers, GST & TDS will be added in the next step on creation of request.',
  NOTE: 'Note',
  DEDUCT_TDS_TWO_PERCENT: 'Deduct TDS @2%',
  APPLICABLE_TO_ALL_ITEMS_OTHER_THAN_STAMP_PAPER: 'applicable to all items other than stamp paper value',
  AADHAAR_ESIGN: 'Aadhaar eSign',
  NESL_COST: 'Nesl Credits',
  APPROVER_COST: 'Approver Credits',
  DOC_SIGNER: 'Doc Signer',
  VERIFIER_CREDITS: 'Verifier Credits',
  AUTOMATED_VIRTUAL_SIGN: 'Automated Virtual Sign',
  AUTOMATED_DOC_SIGN: 'Automated Doc Sign',
  QUICK_SIGN: 'Quick Sign',
  DSC: 'DSC',
  TRANSACTIONS: 'Transactions',
  ADD_ITEMS: 'Add Items',
  SELECT_BILLING_PROFILE: 'Select Billing Profile',
  SELECT: 'Select',
  REPEAT_LAST_PURCHASE: 'Repeat Last Purchase',
  SURE_TO_REPEAT_LAST_ORDER_ACTION_CANNOT_BE_UNDONE: 'Are you sure you want to repeat the last order? This will replace all existing items with the previous purchase.',
  BASE_N_COST: 'Base Cost: {cost}',
  TOTAL_COST: 'Total Cost',
  SUBTOTAL: 'Subtotal',
  GST_EIGHTEEN_PERCENT: 'GST @18%',
  SUB_TDS_TWO_PERCENT: '(-)TDS @2%',
  N_ITEMS: '{n} items',
  CONVENIENCE_FEE: 'Convenience Fee',
  HANDLING_FEE: 'Handling Fee',
  BILL_OF_SUPPLY: 'Bill of Supply',
  COST_WITH_RUPEE: 'Cost (₹)',
  DESCRIPTION: 'Description',
  VIEW_BANK_DETAILS: 'View Bank Details',
  DOWNLOAD_PROFORMA_INVOICE: 'Download Proforma Invoice',
  PAY_COST: 'Pay: ₹{cost}',
  PAYMENT_INSTRUCTIONS: 'Payment Instructions',
  ACCOUNT_NUMBER: 'Account Number',
  BANK_DETAILS: 'Bank Details',
  PAY_EXACT_AMOUNT_THROUGH_NEFT_RTGS_OR_IMPS: 'Pay the total amount to the above account through NEFT, RTFS or IMPS. Please ensure you pay the exact amount set out above (Grand Total) after deducting 2% TDS. Please note that the TDS is not applicable on “Bill of Supply”.',
  AFTER_PAYMENT_OF_EXACT_AMOUNT_PRODUCTS_WILL_BE_ADDED_TO_YOUR_ACCOUNT: 'Once the payment is processed, if the correct amount is paid, we will automatically process the order and add the relevant products to your account wallet. Payment process may take several hours depending on the payment mode used (such as NEFT).',
  EMAIL_NOTIFICATION_AND_TAX_INVOICE_WILL_BE_SENT_AFTER_ADDING_PRODUCTS: 'You will receive an email notification once the products are added & a tax invoice is created against the payment.',
  EXPIRY_INFORMATION: 'Expiry Information',
  ESIGN_WILL_EXPIRY_IN_365_DAYS: 'eSigns will expire in 365 days from the purchase date.',
  STAMPS_WILL_EXPIRE_AS_PER_TIMELINE: 'Stamps will expire as per the timeline prescribed by law.',
  NOTE_LEEGALITY_ENFORCES_SIX_MONTHS_EXPIRY_FOR_ALL_STAMPS: 'Note: Leegality enforces a soft 6 month expiry on all stamp papers from date of purchase.',
  DELETE_PURCHASE_REQUEST: 'Delete Purchase Request',
  SURE_TO_DELETE_PURCHASE_REQUEST_ACTION_CANNOT_BE_UNDONE: 'Are you sure you want to delete this purchase request? This action cannot be undone.',
  PAYMENT_CONFIRMED_ORDER_ID: 'Payment Confirmed - Order ID: {orderId}',
  TAX_INVOICE_WILL_BE_SENT_TO_CONFIG_BILLING_CONTACTS: 'The tax invoice will be sent to the configured billing contacts.',
  IT_TAKES_10_MINS_TO_GENERATE_INVOICE_BALANCE_TO_REFLECT: 'It may take up to 10 minutes for the tax invoice to be generated and updated balance to be reflected.',
  ATTENTION: 'Attention',
  CREATE_ANOTHER_REQUEST: 'Create Another Request',
  ORDER_SUMMARY: 'Order Summary',
  PERSONAL_MONTHLY: 'Personal Monthly',
  PERSONAL_YEARLY: 'Personal Yearly',
  ESSENTIAL_MONTHLY: 'Essential Monthly',
  ESSENTIAL_YEARLY: 'Essential Yearly',
  BUSINESS_MONTHLY: 'Business Monthly',
  BUSINESS_YEARLY: 'Business Yearly',
  CORPORATE_MONTHLY: 'Corporate Monthly',
  CORPORATE_YEARLY: 'Corporate Yearly',
  ENTERPRISE_MONTHLY: 'Enterprise Monthly',
  ENTERPRISE_YEARLY: 'Enterprise Yearly',
  BACK_TO_MAIN_MENU: 'Back to Main Menu',
  MSG_VAL_TEN_DIGIT_PHONE_NUMBER: 'Please enter a 10 digit phone number.',
  SUB_DOMAIN: 'Sub-Domain',
  ADDS_PREFIX_TO_GENERATED_SIGNING_LINK_URL: 'Adds a prefix to the URL generated for your signing links.',
  DOMAIN_LEEGALITY_SIGN_URL_WITH_DOMAIN: 'https://{domain}.{env}.leegality.com/sign/...',
  DOMAIN_LEEGALITY_SIGN_URL_WITHOUT_DOMAIN: 'https://{env}.leegality.com/sign/...',
  SWITCH_OLD_UI: 'Switch to Leegality\'s legacy UI',
  BILL_TO_WITH_COLON: 'Bill to:',
  PRICE_WITH_RUPEE_SIGN: '₹{price}',
  USER_DETAILS: 'User Details',
  ROLE: 'Role',
  DEPARTMENT_USER: 'Department User',
  DEPARTMENT_OWNER: 'Department Owner',
  ENTER_DEPARTMENT_NAME: 'Enter Department Name',
  NEW_DOCUMENT_ACCESS: 'New Document Access',
  NO_USERS_FOUND: 'No Users found',
  NO_OTHER_USERS_PRESENT: 'There are no other users currently in your Leegality organisation.',
  SHARE_DOCUMENTS: 'Share Documents',
  EDIT_USER: 'Edit User',
  LOCK_USER: 'Lock User',
  UNLOCK_USER: 'Unlock User',
  GRANTED: 'Granted',
  REVOKED: 'Revoked',
  NEW_DOC_ACCESS_FOR_NON_ADMIN_USERS: 'New Document Access for non-admin users',
  ENABLED_FOR_ALL: 'Enabled for all',
  DISABLED_FOR_ALL: 'Disabled for all',
  MIXED: 'Mixed',
  ENABLE: 'Enable',
  ENABLE_NEW_DOC_ACCESS_FOR_NON_ADMIN_USERS: 'Enable new document access for all non-admin users',
  ARE_YOU_SURE_TO_ENABLE_NEW_DOC_ACCESS_FOR_NON_ADMIN_USERS: ' Are you sure you want to enable new document access for all non-admin users? All non-admin users will be able to use new document flow.',
  DISABLE_NEW_DOC_ACCESS_FOR_NON_ADMIN_USERS: 'Disable new document access for all non-admin users',
  ARE_YOU_SURE_TO_DISABLE_NEW_DOC_ACCESS_FOR_NON_ADMIN_USERS: ' Are you sure you want to disable new document access for all non-admin users? All non-admin users will not be able to use new document flow.',
  BILLING: 'Billing',
  DEPARTMENT_ADMIN: 'Department Admin',
  LOCKED: 'Locked',
  ARE_YOU_SURE_TO_LOCK_USER: 'Are you sure want to lock this user?',
  ARE_YOU_SURE_TO_UNLOCK_USER: 'Are you sure want to unlock this user?',
  ORGANISATION_ID: 'Organisation ID',
  NEW_USERS: 'New Users',
  NO_NEW_USER_HAS_BEEN_ADDED_YET: 'No new user has been added yet',
  ADD_NEW_USER_PROFILE_BY_CLICKING_BUTTON_BELOW: 'Add new user profile by clicking the button below',
  RESEND_INVITATION: 'Resend Invitation',
  DELETE_INVITATION: 'Delete Invitation',
  CREATE_USER: 'Create User',
  USER_ROLE: 'User Role',
  SELECT_USER_ROLE: 'Select User Role',
  SELECT_DEPARTMENT: 'Select Department',
  ALLOW_TO_CREATE_DOCUMENTS_VIA_NEW_DOCUMENT_FLOW: 'Allow this user to create documents via Leegality’s "New Document" flow which does not restrict the user to any default settings.',
  AUTO_ACTIVATE: 'Auto-Activate',
  RELEVANT_TO_ORGANIZATION_USING_SSO_LOGIN: 'This is only relevant for organisations using SSO login.',
  DELETE_INVITATION_COLON_NAME: 'Delete Invitation: {name}',
  SURE_TO_DELETE_INVITATION_CANNOT_BE_UNDONE: 'Are you sure you want to delete this user invitation? This action cannot be undone',
  DATE_CREATED: 'Date Created',
  MOBILE_UNSUPPORTED_SCREEN_HEADER: 'We mean well :)',
  MOBILE_UNSUPPORTED_SCREEN_DESCRIPTION: 'For the best experience, please access this page from a desktop device.',
  I_WANT_TO_CONTINUE: 'I want to continue',
  SAMPLE_NAME: 'Sample Name',
  ALLOW_USERS_TO_CREATE_DOCUMENT: 'Allow this user to create document via Leegality’s “New Document” flow which does not restrict the user to any default settings.',
  ATLEAST_ONE_ACTIVE_ADMIN_REQUIRED: 'At least one active admin is required.',
  EDITED_USER_DETAILS_SUCCESSFULLY: 'User details saved successfully.',
  DEFAULT_LOW_BALANCE_THRESHOLDS: 'Default Low Balance Thresholds',
  SET_CUSTOM_LOW_BALANCE_NOTIFICATION_THRESHOLDS: 'Set Custom Low Balance Notification Thresholds',
  CUSTOMIZE_LOW_BALANCE_NOTIFICATIONS_LIMIT: 'You can customize the limit at which you would like to receive the low balance notification.',
  ESIGN_CREDITS_WITH_COLON: 'eSign Credits:',
  STAMP_PAPERS_WITH_COLON: 'Stamp Papers:',
  NOTIFICATION_TRIGGERED_AT: 'Notification triggered at',
  CONSUMPTION_OF_MOST_RECENT_ESIGN_PURCHASE: 'consumption of most recent eSign purchase.',
  CONSUMPTION_OF_STAMP_SERIES_MOST_RECENT_STAMP_PURCHASE: 'consumption of each stamp series, from the most recent Stamp purchase.',
  FIFTY_SEVENTY_FIVE_NINETY_PERCENT: '50%, 75%, 90% and 100%',
  PERCENTAGE_CONSUMPTION_OF_RECENT_ESIGN_PURCHASE: 'Percentage consumption of most recent eSign purchase',
  PERCENTAGE_CONSUMPTION_OF_RECENT_STAMP_PURCHASE: 'Percentage consumption of each stamp series, from the most recent Stamp purchase',
  ENTER_PERCENTAGE: 'Enter Percentage',
  SET_DEFAULT_LOW_BALANCE_THRESHOLD: 'Set default low balance threshold.',
  SURE_TO_SET_DEFAULT_LOW_BALANCE_THRESHOLD: 'Are you sure you want to set default low balance threshold.? This will override the custom low balance thresholds.',
  SET_CUSTOM_LOW_BALANCE_THRESHOLD: 'Set custom low balance threshold.',
  SURE_TO_SET_CUSTOM_LOW_BALANCE_THRESHOLD: 'Are you sure you want to set custom low balance threshold.? This will override the default low balance thresholds.',
  LAST_PURCHASE_ADDED_SUCCESSFULLY: 'Last purchase added successfully.',
  APPLICABLE_TO_ALL_ITEMS_OTHER_THAN_STAMP_PAPER_WITH_CAPS: 'Applicable to all items other than stamp paper value',
  THIS: 'This',
  ADD_BALANCE: 'Add Balance',
  UNEXPECETD_ERROR_OCCURED: 'Unexpected error occurred.',
  SHARE_DOCUMENTS_FOR: 'Share documents for',
  ADD_TEAM_MEMBERS: 'Add team members',
  PEOPLE_WITH_ACCESS: 'People with access:',
  MOBILE_DISCLAIMER: 'Mobile Disclaimer',
  ACCESS_ACCOUNT_SETTINGS_FROM_DESKTOP_NOTE: 'Access account settings from a desktop to access all of your account settings.',
  UNSAVED_CHANGES: 'Unsaved Changes',
  SURE_CLOSE_TO_CLOSE_MODAL_UNSAVED_CHANGES: 'Are you sure you want to close this modal? All unsaved changes will be lost.',
  DELETE_RECIPIENT: 'Delete Recipient',
  SURE_TO_DELETE_RECIPIENT: 'Are you sure you want to delete this Recipient? They will stop receiving this notification.',
  UPDATE_RECIPIENT: 'Update Recipient',
  DISCARD_CHANGES: 'Discard Changes',
  ADD_NEW: 'Add New',
  SUCCESSFULLY_ADDED_TEST_TEMPLATE: 'Successfully added test template',
  SAMPLE_TEST_TEMPLATE_ADDED_TO_YOUR_ACCOUNT: 'A sample template has been added to your account',
  ALL_INVITEES: 'All Invitees',
  CLICK_TO_PURCHASE_ESIGN_CREDITS_AND_START_EXECUTING_DOCS:
    'Click on the button below to purchase eSign credits and start executing documents.',
  INVITATION_EXPIRY_DATE_LATER_THAN_CONFIG_THAN_LATER_EXPIRY_DATE_WILL_BE_ASSIGNED:
    'If any of the invitations in this document have a later expiry date than what is configured here, the later expiry date will be assigned to this invitation',
  REQUEST_BEING_PROCESSED: 'Your request will be processed shortly.',
  DONT_LEAVE_OR_REFRESH_PAGE: 'Please do not refresh or leave this page until the request is complete.',
  FOLDER: 'Folder',
  BACK_TO_N_FOLDER: 'Back to {n} folder',
  BACK_TO_DASHBOARD: 'Back to Dashboard',
  DOCUMENT_DETAILS: 'Document Details',
  DOCUMENT_NAME: 'Document Name',
  AADHAAR_E_SIGN: 'Aadhaar eSign',
  SIGN_TYPE: 'Sign Type',
  SIGN_TIME: 'Sign Time',
  COMBINATIONS: 'Combinations',
  COMBINATION_N: 'Combination {number}',
  COMBO: 'Combo',
  VERIFICATION_RESULT: 'Verification Result',
  DOC_ID: 'Doc ID',
  PACK_URN: 'Pack URN',
  PACK: 'Pack',
  REASON: 'Reason',
  RECTIFY: 'Rectify',
  INVITEE_LIST: 'Invitee List',
  UNSIGNED: 'Unsigned',
  REFERENCE_ATTACHMENT: 'Reference Attachment',
  COPY_URL: 'Copy URL',
  RESEND_NOTIFICATION: 'Resend Notification',
  AUDIT_TRAIL: 'Audit Trail',
  N_REQUIRED_FOR_GROUP_COMPLETION: '({n} required for group completion)',
  YOU_DONT_HAVE_ANY_INVITEES_ADDED_YET: 'You don’t have any invitees added yet.',
  NO_INVITEES_CLICK_OPEN_BUTTON_TO_ADD: 'You don’t have any invitees added yet. Please click on open and add invitees',
  YOU_DONT_HAVE_ANY_INVITEES: 'You don’t have any invitees.',
  VIEW_MORE: 'View More',
  VIEW_LESS: 'View Less',
  N_INVITATIONS_COMPLETED: '{n} Invitations Completed',
  INVITEE_DETAILS: 'Invitee Details',
  INVITATION_DATE: 'Invitation Date',
  SIGNED_USING: 'Signed Using',
  SIGN_DATE: 'Sign Date',
  EXPIRY: 'Expiry',
  ESIGN_VERIFICATION_DETAILS: 'eSign Verification Details',
  SELECT_INVITEE: 'Select Invitee',
  SIGNATURE_VERIFICATION_SUCCESSFUL: 'Signature Verification Successful',
  SIGNATURE_VERIFICATION_FAILED: 'Signature Verification Failed',
  LAST_FOUR_DIGITS_OF_AADHAAR: 'Last 4 digits of Aadhaar',
  RESULT: 'Result',
  INPUT_VALUE: 'Input Value',
  CERTIFICATE_VALUE: 'Certificate Value',
  MATCH_RESULT: 'Match Result',
  AI_RESULT: 'AI Result',
  VERIFICATION: 'Verification',
  DELETE_INVITEE_NAME: 'Delete Invitee - {name}',
  DELETE_GROUP_NAME: 'Delete Group - {name}',
  DELETE_CC_NAME: 'Delete CC - {name}',
  SURE_TO_DELETE_THIS_INVITEE_ACTION_CANNOT_BE_UNDONE:
    'Are you sure you want to delete this invitee? This action cannot be undone.',
  SURE_TO_DELETE_THIS_CC_ACTION_CANNOT_BE_UNDONE:
    'Are you sure you want to delete this cc? This action cannot be undone.',
  SURE_TO_DELETE_THIS_GROUP_ACTION_CANNOT_BE_UNDONE:
    'Are you sure you want to delete this group? This action cannot be undone.',
  MESSAGE_OPTIONAL: 'Message (Optional)',
  SURE_TO_REJECT_THIS_INVITATION: 'Are you sure you want to reject this invitation?',
  SURE_TO_REINVITE_THIS_INVITATION: 'Are you sure you want to re-invite this invitation?',
  DOCUMENT_COMPLETE: 'Document Complete',
  SURE_TO_COMPLETE_THIS_DOCUMENT: 'Are you sure you want to manually complete this document?',
  SUPPORTING_DOCUMENTS: 'Supporting Documents',
  DOCUMENT_IDS: 'Document IDs',
  CC_DELETED_SUCCESSFULLY: 'CC Deleted Successfully',
  BACK_TO_DETAILS_PAGE: 'Back To Details Page',
  FULL_SCREEN: 'Full Screen',
  SUCCESS: 'Success',
  FACE: 'Face',
  EDIT_PASSWORD: 'Edit Password',
  SFTP_LIMIT_EXCEEDED: 'SFTP profile limit exceed',
  NESL: 'Nesl',
  NESL_ERROR: 'NeSL Error',
  VIEW_ERROR: 'View Error',
  COMPLETE_GROUP: 'Complete Group',
  COMPLETE_INVITEE_MANUALLY: 'Complete Invitee manually?',
  MARK_GROUP_AS_COMPLETE: 'Mark Group as Complete?',
  INVITEE_CANNOT_CONTINUE: 'Invitee will no longer be able to sign or review their remaining documents. This action cannot be undone.',
  PENDING_SIGNERS_CANNOT_CONTINUE: 'Pending signers will no longer be able to sign or review their remaining documents. This action cannot be undone.',
  COMPLETE_MANUALLY: 'Complete manually',
  MARK_AS_COMPLETED: 'Mark as Completed',
  NESL_TRANSACTION_ID: 'NeSL Transaction ID',
  NESL_TRANSACTION_ID_LABEL_WITH_ID: 'NeSL Transaction ID: {id}',
  ERROR_CODE_WITH_CODE: 'Error Code: {code}',
  ISSUE_WHILE_PROCESSING_REQUEST_WITH_NESL_SERVER: 'We\'re sorry, but we\'ve encountered an issue while processing your request. The error might be due to a temporary issue with NeSL\'s servers.',
  YOU_CAN_CLICK_ON: 'You can click on',
  TO_TRY_AGAIN: 'to try again.',
  AUTO_RETRY_PROGRESS: 'Auto-retry {count}/{max}',
  AUTO_RETRY_EXHAUSTED: 'Retried {max}/{max} · No more auto-retries',
  AUTO_RETRY_ATTEMPTS: 'Auto-Retry Attempts',
  ATTEMPT_COUNT_OF_MAX: '{count} of {max}',
  TEMPORARY_SUBMISSION_ISSUE: 'Temporary Submission Issue',
  RETRY_FAILED: 'Retry failed',
  SAVE_DOCUMENT_TO_LEEGALITY: 'Save Document To Leegality',
  DOC_WILL_BE_DELETED_ON_DATE: 'Document will be deleted on {date}.',
  LEAVE_PASSWORD_BLANK: 'Leave the password field blank to retain the existing password',
  MESSAGE: 'Message',
  REJECTION_MESSAGE: 'Rejection Message',
  ENTER_EMAIL_TO_SEND_COPY_OF_DOCUMENT: 'Please enter the email ID to send a copy of this document.',
  SHARE_DOCUMENT: 'Share Document',
  PHONE: 'Phone',
  PAYMENT_ID: 'Payment Id',
  PAYMENT_DATE: 'Payment Date',
  PAYMENT_STATUS: 'Payment Status',
  EXPIRY_REASON: 'Expiry Reason',
  REFRESH_STATUS: 'Refresh Status',
  REFRESH_DOCUMENT: 'Refresh Document',
  APPROVED: 'Approved',
  RE_INVITE: 'Re-Invite',
  GST_TDS_WILL_BE_ADDED_ON_NEXT_PAGE: 'GST & TDS will be added in the next step on creation of request.',
  CLICK_TO_UPLOAD_FILE_NAME: 'Click to Upload {file} File',
  SIGNING_JOURNEY_CANCELLED: 'Signing journey cancelled',
  VIEW_PAYMENT_LOGS: 'View Payment Logs',
  PAYMENT_LOGS: 'Payment Logs',
  UNPAID: 'Unpaid',
  CAPTURED: 'Captured',
  AMOUNT: 'Amount',
  CERTIFICATE_DETAILS: 'Certificate Details',
  INVITEE: 'Invitee',
  NOTIFICATION_LOG: 'Notification Log',
  NOTIFICATION_LOGS: 'Notification Logs',
  EMAIL_ID_OR_MOBILE_NUMBER: 'Email Id/Mobile Number',
  CHANNEL: 'Channel',
  NOTIFICATION_TYPE: 'Notification Type',
  WHATSAPP: 'Whatsapp',
  TIMESTAMP: 'Timestamp',
  DOCUMENT_HAS_BEEN_DELETED: 'Document has been deleted',
  SUCCESSFULLY_UPLOADED_FILES: 'Successfully uploaded files',
  DUPLICATE_LABEL_FOUND: 'Duplicate {label} found',
  TAG_LIMIT_EXCEED_MSG: 'Only {maxItems} labels can be assigned to a {contact}.',
  MSG_ASCII_CHAR: 'Please remove special characters',
  MSG_ASCII_CHAR_WITH_RESTRICTION: 'Allowed input includes alphanumeric characters and | - : () , _ . [] & / # + @ ; \' –',
  MSG_ASCII_CHAR_WITH_RESTRICTION_I: 'Allowed input includes alphanumeric characters and , & . () [] _ - \' " , ! * + | @ # ?',
  MSG_RESTRICTED_ASCII_CHARS: 'Allowed input includes alphanumeric characters and | - : () , _ . [] & / # + @',
  DOSENT_APPLY_TO_PDF_WITH_DIGITAL_SIGN: 'Does not apply to PDFs which contain digital signature',
  DISABLE_OTP_AUTH_FOR_REVIEWER: 'Disable OTP authentication for Reviewer',
  NO_PAYMENT_GATEWAY_PROFILES_FOUND: 'No Payment Gateway profiles found',
  ADD_NEW_PAYMENT_GATEWAY_PROFILE_TO_ENABLE_COLLECTION: 'Add a new Payment Gateway profile to enable payment collection in the signing journey.',
  SELECT_PAYMENT_GATEWAY: 'Select Payment Gateway',
  WILL_BE_REDIRECTED_TO_RAZORPAY_MERCHANT_FOR_LINKING: 'You will be redirected to Razorpay for linking your merchant account with Leegality.',
  LINK_YOUR_BILLDESK_ACCOUNT_WITH_LEEGALITY: 'Link your BillDesk merchant account with Leegality',
  RAZORPAY: 'Razorpay',
  BILLDESK: 'BillDesk',
  CONFIG_PAYMENT_GATEWAYS: 'Configured Payment Gateway’s',
  LINK_YOUR_PAYMENT_GATEWAY_TO_YOUR_LEEGALITY_ORG: 'Link your payment gateway to your Leegality Organisation.',
  SENDER_CAN_CONFIG_PAYMENT_FROM_SIGNER_REVIEWER_BY_JOURNEY: 'Sender’s will be able to configure payment collection from Signers & Reviewers in the signing/reviewer journey.',
  PAYMENT_GATEWAY: 'Payment Gateway',
  PAYMENT_COLLECTION_ENABLED: 'Payment collection enabled.',
  SENDER_CAN_CONFIG_PAYMENT_COLLECTION_FROM_SIGNER_REVIEWER_JOURNEY: 'Sender’s will now be able to configure payment collection from Signers & Reviewers in the signing/reviewer journey.',
  PAYMENT_COLLECTION_DISABLED: 'Payment collection disabled.',
  SENDER_CANNOT_CONFIG_PAYMENT_COLLECTION_FROM_SIGNER_REVIEWER_JOURNEY: 'Sender’s will not be able configure payment collection from Signers & Reviewers in the signing/reviewer journey.',
  LINK_BILLDESK_ACCOUNT_WITH_LEEGALITY: 'Link BillDesk Account With Leegality',
  EDIT_BILLDESK_ACCOUNT_DETAILS: 'Edit BillDesk Account Details',
  BILLDESK_ACCOUNT_DETAILS_UPDATED_SUCCESSFULLY: 'BillDesk Account Details Updated Successfully',
  LINK_RAZORPAY_ACCOUNT_WITH_LEEGALITY: 'Link Razorpay Account With Leegality',
  ADD_NEW_PAYMENT_PROFILE: 'Add new Payment Profile',
  ADD_PAYMENT_PROFILE: 'Add Payment Profile',
  ENTER_MERCHANT_ID: 'Enter Merchant ID',
  ENTER_CLIENT_ID: 'Enter Client ID',
  HMAC_KEY: 'HMAC Key',
  ENTER_HMAC_KEY: 'Enter HMAC Key',
  LINK: 'Link',
  BILLDESK_ACCOUNT_LINKED_SUCCESSFULLY: 'BillDesk merchant account linked successfully.',
  PROFILE_NAME_UPDATED_SUCCESSFULLY: 'Profile Name Updated Successfully',
  SMS_SENT_SINCE_WHATSAPP_NOT_LINKED: 'SMS has been sent since WhatsApp isn’t linked with this number.',
  CLICK: 'Click',
  TO_KNOW_MORE: 'to know more',
  SAVE_DOC_IN_CENTRAL_REPO_BY_SIGNING_IN_TO_LEEGALITY: 'To save your document in a central repository, you should sign up with Leegality & store the document in Leegality',
  SAVE_DOCUMENT: 'Save Document',
  GROUP_SIGN_IS_COMPLETE: 'Group sign is complete',
  GROUP_REVIEW_IS_COMPLETE: 'Group review is complete',
  AMOUNT_WITH_RUPEE: 'Amount (₹)',
  RETRY_ATTEMPTS: 'Retry Attempts',
  FACE_MATCH: 'Face Match',
  SMART_USER_LIVELINESS: 'Smart User Liveliness',
  SMART_USER_LIVELINESS_VERSION_2_BETA: 'Smart User Liveliness Version 2.0 (Beta)',
  PII_MASKING: 'Mask PII data for Invitees',
  RETRY_ATTEMPTS_FOR_NAME_HAVE_EXHAUSTED: 'Retry attempts for {name} have exhausted.',
  EDIT_DOC_AND_INCREASE_RETRY_ATTEMPTS: 'Please edit the document and increase Retry attempts',
  SUPPORT_ARTICLES: 'Support Articles',
  API_DOCUMENTATION: 'Api Documentation',
  CHANGELOG: 'Changelog',
  PRODUCT_UPDATES: 'Product Updates',
  NESL_EBG_STAMPING_COST: 'Nesl Stamping Credits',
  WHATSAPP_TRANSACTION: 'Whatsapp Credits',
  FACE_MATCH_TRANSACTION: 'Face Match Verification Credits',
  SMART_USER_LIVELINESS_TRANSACTION: 'Smart User Liveliness Credits',
  MSG_PAGE_ACCESS_DENIED: 'You don\'t have access to this page',
  REVIEWED: 'Reviewed',
  NOT_REVIEWED: 'Not Reviewed',
  FINALIZE: 'Finalize',
  INVITE: 'Invite',
  ADD_INSTRUCTIONS: 'Add Instructions',
  AUTHORIZED: 'Authorized',
  INITIATED: 'Initiated',
  REFUNDED: 'Refunded',
  NOTHING_TO_UPDATE: 'Nothing to update',
  IN_PROGRESS: 'In Progress',
  PROFILE_ID_COLON_ID: 'Profile ID: {id}',
  PAYMENT_CONFIG_NOT_ENABLED_CONTACT_SUPPORT: 'Payment configuration not enabled for this account. Please contact support team.',
  NESL_FORM: 'NeSL Form',
  FORM_SECTIONS: 'Form Sections',
  REGISTRATION_TYPE: 'Registration Type',
  SIGNERS: 'Signers',
  PARTIES: 'Parties',
  PARTY: 'Party',
  LOAN: 'Loan',
  SECURITIES: 'Securities',
  REFERENCE_ATTACHMENTS: 'Reference Attachments',
  ATTACHMENT_NAME: 'Attachment Name',
  ENTER_ATTACHMENT_NAME: 'Enter Attachment Name',
  PDF_PNG_JPG_JPEG_MAX_SIZE_MB: 'PDF, PNG, JPG, JPEG (max. {size}MB)',
  UPLOADED_ATTACHMENTS: 'Uploaded Attachments',
  PARTICIPANTS: 'Participants',
  ENTITY_DETAILS: 'Entity Details',
  ENTITY: 'Entity',
  ENTITY_PAN: 'Entity PAN',
  NESL_PARTIES: 'NeSL Parties',
  NESL_SECURITIES: 'NeSL Securities',
  DATE_OF_BIRTH_INCORPORATION: 'Date of Birth/Incorporation',
  REGISTERED_ADDRESS_PINCODE: 'Registered Address Pin Code',
  KYC_IDENTIFICATION_NO: 'KYC Identification No.',
  FIRST_PARTY_ID_TYPE: 'First Party ID Type',
  FIRST_PARTY_ID_NUMBER: 'First Party ID Number',
  SECOND_PARTY_ID_TYPE: 'Second Party ID Type',
  SECOND_PARTY_ID_NUMBER: 'Second Party ID Number',
  DATE_OF_CREATION: 'Date of Creation',
  DATE_OF_VALUATION: 'Date of Valuation',
  VISUAL_SIGN_SETUP: 'Visual Sign Setup',
  VISUAL_SIGN: 'Visual Sign',
  IMAGE_AFFIXED_DOC_WITHOUT_DIGITAL_SIGN: 'An image of the signature will be affixed on the document without a digital signature or timestamps.',
  CORPORATE_IDENTIFICATION_NUMBER: 'Corporate Identification Number',
  CERSAI_ID: 'CERSAI Id',
  ROC_CHARGE_ID: 'RoC Charge Id',
  DOCUMENT_REFERENCE_NUMBER: 'Document Reference Number',
  CONTRACT_REFERENCE_NUMBER: 'Contract Reference Number',
  PAGE_X_OF_Y: 'Page {x} of {y}',
  NESL_PROFILES: 'NeSL Profiles',
  EBG_EVENT_REVIEWERS: 'eBG Event Reviewers',
  MSG_REVIEWER_WILL_RECEIVE_NOTIFICATIONS: 'Reviewers configured below will receive notifications for all events regardless of their event type. Although, reviewers will only be allowed to accept or reject requests for the event type they have been added to.',
  EBG_NOTIFICATIONS: 'eBG Notifications',
  ALL_EVENTS: 'All Events',
  AMENDMENT: 'Amendment',
  PARTIAL_INVOCATION: 'Partial Invocation',
  INVOCATION: 'Invocation',
  CANCELLATION: 'Cancellation',
  CLOSURE: 'Closure',
  EXTEND_OR_PAY: 'Extend or Pay',
  RENEWAL: 'Renewal',
  EVENT_TYPES: 'Event Types',
  COUNT_REVIEWERS_CONFIGURED: '{count} reviewers configured',
  NO_REVIEWERS_CONFIGURED: 'No Reviewers Configured',
  EMAIL_ADDRESS: 'Email Address',
  ADD_REVIEWER: 'Add Reviewer',
  EDIT_REVIEWER: 'Edit Reviewer',
  DELETE_REVIEWER: 'Delete Reviewer',
  DISCARD_REVIEWER: 'Discard Reviewer',
  DELETE_EVENT_REVIEWER: 'Delete Event Reviewer',
  MSG_SURE_TO_DELETE_REVIEWER: 'Are you sure you want to delete this Event Reviewer? They will not be able to review any more notifications for this event.',
  ENTER_REVIEWER_NAME: 'Enter Reviewer Name',
  ENTER_REVIEWER_EMAIL_ID: 'Enter Reviewer Email ID',
  ENTER_EMAIL_ID: 'Enter Email ID',
  SENT_TO_ME: 'Sent To Me',
  SENT_TO_ALL: 'Sent To All',
  PENDING: 'Pending',
  NO_NOTIFICATIONS_FOUND: 'No notifications found',
  NO_NOTIFS_UNDER_THIS_CATEGORY: 'There are no notifications to review under this category',
  UPDATED_BY: 'Updated By',
  UPDATED_AT: 'Updated At',
  WITHDRAWAL_REQUEST_TXN_ID: 'Withdrawal Request Txn ID',
  WITHDRAWAL_REQUEST_ID: 'Withdrawal Request ID',
  WITHDRAWAL_SOURCE_OF_REQUEST: 'Withdrawal Source of Request',
  WITHDRAWAL_REQUESTOR_TYPE: 'Withdrawal Requestor Type',
  WITHDRAWAL_REQUEST_SUBMITTED_ON: 'Withdrawal Request Submitted On',
  WITHDRAWAL_PORTAL_ID: 'Withdrawal Portal ID',
  SYSTEM_BENEFICIARY: 'System (Beneficiary)',
  MARK_AS_OUTDATED: 'Mark as Outdated',
  OUTDATED_NOTIFICATION: 'Outdated Notification',
  OUTDATED_ON_REVIEW_CONFIRM_BODY: 'As per NeSL, this notification is outdated and can no longer be reviewed. Do you want to move it to Archive?',
  MARK_OUTDATED_CONFIRM_BODY: 'Mark this notification as outdated and move it to Archive? It can no longer be reviewed once moved.',
  MOVE_TO_ARCHIVE: 'Move to Archive',
  NOTIFICATION_MOVED_TO_ARCHIVE: 'Notification moved to Archive',
  MOVE_TO_PENDING: 'Move to Pending',
  UNARCHIVE_NOTIFICATION: 'Unarchive Notification',
  UNARCHIVE_CONFIRM_BODY: 'Move this notification back to Pending so it can be reviewed again?',
  NOTIFICATION_MOVED_TO_PENDING: 'Notification moved to Pending',
  LOAN_NUMBER: 'Loan Number',
  EVENT: 'Event',
  REVIEWED_BY: 'Reviewed By',
  REVIEW_FORM: 'Review Form',
  ACTION_EBG_NOTIFICATION: '{action} eBG Notification',
  ARE_YOU_SURE_ACCEPT_REJECT_EBG: 'Are you sure you want to {action} this eBG notification? This action cannot be undone.',
  ENTER_REMARKS_FOR_ACTION: 'Enter remarks for your action',
  ACCEPT: 'Accept',
  REQUEST_DETAILS: 'Request Details',
  SUPPORTING_DOCUMENT: 'Supporting Document',
  PARTY_DETAILS: 'Party Details',
  SOURCE_OF_REQUEST: 'Source of Request',
  REQUESTOR_TYPE: 'Requestor Type',
  TYPE_OF_REQUEST: 'Type of Request',
  REQUESTOR_REMARKS: 'Requestor Remarks',
  REQUESTOR_ENTITY_NAME: 'Requestor Entity Name',
  REQUESTOR_NAME: 'Requestor Name',
  IFSC_CODE: 'IFSC Code',
  CONTACT_PERSON_DEPARTMENT: 'Contact Person Department',
  CONTACT_PERSON_PHONE: 'Contact Person Phone',
  CONTACT_PERSON_EMAIL: 'Contact Person Email',
  FULL_NAME: 'Full Name',
  OFFICIAL_DOC_TYPE: 'Official Doc Type',
  OFFICIAL_DOC_ID: 'Official Doc ID',
  CONTRACT_RELATION: 'Contract Relation',
  BUSINESS_UNIT_CODE: 'Business Unit Code',
  SANCTION_CURRENCY: 'Sanction Currency',
  CURRENCY_OF_DEBT: 'Currency of Debt',
  DEAL_COLLABORATION: 'Deal Collaboration',
  COLLAPSE: 'Collapse',
  EXPAND: 'Expand',
  EBG_DETAILS: 'eBG Details',
  PARTICIPANT: 'Participant',
  NOTIFICATION_TXN_ID: 'Notification Txn ID',
  DC_SUBSCRIPTION_BALANCE: 'DC Subscription Balance',
  ACCEPTED_SUCCESSFULLY: 'Accepted Successfully',
  REJECTED_SUCCESSFULLY: 'Rejected Successfully',
  ONLY_10_DAYS_LOGS_VISIBLE: 'Logs are displayed here for the last 10 days only. Older logs are not available.',
  STATUS_REMARKS: 'Status Remarks',
  NO_LOGS_FOUND_FOR_TODAY: 'No logs found for today!',
  NO_NOTIFICATION_LOGS_NEW_LOG_WILL_APPEAR_HERE: 'New logs will appear as they are generated. Filter by date for older logs (within the last 10 days).',
  SELECTED_DATE_RANGE_EXCEEDS_LIMIT: 'Selected date range exceeds maximum limit ({limit})',
  COUNT_YEARS: '{count} years',
  COUNT_DAYS: '{count} days',
  READ: 'Read',
  ALERT: 'Alert',
  DELIVERED: 'Delivered',
  RETAIN_DOCUMENT: 'Retain Document',
  DELETE_DOCUMENT: 'Delete Document',
  SURE_TO_DELETE_IT: 'Are you sure you want to delete it?',
  SURE_TO_DELETE_IT_FROM_LEEGALITY: 'Are you sure you want to delete it from Leegality?',
  DELETE_EXPIRED_DOC_NOT_REMOVE_IT_FROM_NESL: 'This document has expired. Deleting it from Leegality will NOT remove it from NeSL. This action is irreversible.',
  DELETE_DOC_FROM_LEEGALITY_AND_NESL_AND_INVALIDATE: 'Deleting this document from Leegality will also delete it from NeSL and invalidate the signing links. This action is irreversible.',
  DELETE_SIGNED_NESL_DOC_WILL_NOT_DELETE_FROM_NESL: 'This document is signed from NeSL. Deleting it from Leegality will NOT remove it from NeSL. This action is irreversible.',
  DELETE_COMPLETED_NESL_DOC_WILL_NOT_DELETE_FROM_NESL: 'This document is completed. Deleting it from Leegality will NOT remove it from NeSL. This action is irreversible.',
  STAMPED_FROM_NESL_DOC_WILL_NOT_DELETE_FROM_NESL: 'This document is stamped from NeSL. Deleting it from Leegality will NOT remove it from NeSL. This action is irreversible.',
  PORTAL_ID: 'Portal ID',
  PASS_RESET_CODE_GENERATED_SUCCESS: 'Password reset code generated successfully.',
  PASS_UPDATE_SUCCESS: 'Password updated successfully.',
  NESL_STAMPS: 'NeSL Stamp(s)',
  ASK_ME_ANYTHING: 'Ask me anything!',
  VERSION_HISTORY: 'Version History',
  VIEW_HISTORY: 'View History',
  CHANGE_VERSION_STATUS: 'Change Version Status?',
  MSG_WANT_TO_CHANGE_VERSION_STATUS: 'Do you want to change the status of the version?',
  CHANGE_OR_UPDATE_WORKFLOW_VERSION: 'Change or update the workflow versions here',
  V4_WORKFLOWS: 'V4 Workflows',
  V3_WORKFLOWS: 'V3 Workflows',
  V4_TEMPLATES: 'V4 Templates',
  VER_NO: 'Ver. No.',
  VERSION_NAME: 'Version Name',
  PUBLISHED_DATE: 'Published Date',
  DUPLICATE: 'Duplicate',
  PUBLISH: 'Publish',
  DUPLICATE_TEMPLATE: 'Duplicate Template',
  FORMAT: 'Format',
  RENAME_VERSION: 'Rename Version',
  RENAME_VERSION_DESCRIPTION: 'Add version name to identify between different versions',
  ENTER_VERSION_NAME: 'Enter version name',
  VERSION_RENAMED_SUCCESSFULLY: 'Version renamed successfully',
  UPLOAD_NEW_PDF: 'Upload New PDF',
  UPLOAD_NEW_PDF_DESCRIPTION: 'Replace an existing pdf file for your template',
  SUPPORTED_FORMAT_PDF: 'Supported format: pdf',
  PDF_UPLOADED_SUCCESSFULLY: 'PDF uploaded successfully',
  LOADING: 'Loading...',
  IN_A_MOMENT_YOUR_FILES_WILL_BE_READY_FOR_REVIEW: 'In a moment, your files will be ready for review.',
  PLEASE_HOLD_ON: 'Please hold on.',
  EDIT_AND_UPGRADE: 'Edit and Upgrade',
  TEMPLATE_UPGRADED_SUCCESSFULLY: 'Template upgraded successfully',
  TEMPLATE_CREATED_SUCCESSFULLY: 'Template created successfully',
  REMOVE_WORKFLOW_FROM_SYSTEM: 'Remove the workflow from the system',
  MOVE_WORKFLOW_TO_ARCHIVED_STATE: 'Move the workflow to an archived state',
  RUN_WORKFLOW_V4_OPTIONS: 'run_workflow_v4_options',
  PACK_NAME: 'Pack Name',
  RUN_CONTEXT_ID: 'RunContextId',
  PACK_ID: 'Pack ID',
  PACK_IRN: 'Pack IRN',
  PACK_FOLDER: 'Pack Folder',
  COMPLETED_ON: 'Completed On',
  PACKS: 'Packs',
  NO_PACKS_FOUND: 'No packs found',
  NO_PACKS_DESCRIPTION: 'There are no packs matching your current filters',
  FETCH_WORKFLOW_RUN_DETAILS_FAILED: 'Failed to fetch workflow run details',
  PUBLISHED: 'Published',
  PARTIALLY_SIGNED: 'Partially Signed',
  PARTIALLY_APPROVED: 'Partially Approved',
  PARTIALLY_REJECTED: 'Partially Rejected',
  LOAD_MORE_STAMPS: 'Load More Stamps',
  PACK_COMPLETE: 'Pack Complete',
  SURE_TO_COMPLETE_THIS_PACK: 'Are you sure you want to manually complete this pack?',
  PACK_PENDING_COMPLETION: 'Pack Pending Completion',
  REVIEW_TIME: 'Review Time',
  ACTION_APPLIED_TO_PACK: 'This will reactivate all invitees across every document in this pack',
  BY: 'By',
  WORKFLOW_NAME_ARCHIVED: 'Workflow {workflowName} archived',
  DOCUMENT_NOT_SIGNED_YET: 'Document not signed yet',
  PLEASE_WAIT_FOR_SIGNER_TO_FINISH_OR_SEND_REMINDER: 'Please wait for the signer to finish the document or send a reminder notification.',
  SEE_MORE: 'See more',
  PACK_DETAILS: 'Pack Details',
  USED_AND_RESERVED: 'Used & Reserved',
  TEXT_MIN_ORDER_QUANTITY_CHARGE: 'You have been charged convenience fee of {quantity} due to shortfall of {MOQDiff} stamps as per the minimum order quantity.',
  FAILED_TO_FETCH_PACKS: 'Failed to fetch packs',
  FAILED_TO_DELETE_PACK: 'Failed to delete pack',
  PACK_DELETED_SUCCESSFULLY: 'Pack deleted successfully',
  APPLY_FILTERS_TO_TABLE: 'Apply filters to table data',
  TIMELINE: 'Timeline',
  SELECT_FOLDERS: 'Select Folders',
  ENTER_PACK_NAME: 'Enter Pack Name',
  ENTER_PACK_ID: 'Enter Pack ID',
  ENTER_PACK_IRN: 'Enter Pack IRN',
  PACK_MOVED_SUCCESSFULLY: 'Pack moved successfully',
  FAILED_TO_MOVE_PACK: 'Failed to move pack',
  VIEW_SUPPORTING_DOCS: 'View Supporting document(s)',
  BETA: 'Beta',
  NESL_INVITEE_PRESENT_WARNING: 'NeSL Invitation Present. Reactivation works only after NeSL also reactivates eSign links. Until then, NeSL signers cannot eSign.',
  NESL_REACTIVATION_BLOCKED: 'Reactivation blocked due to a failed NeSL response.',
  SAVING: 'Saving…',
  EXIT_PREVIEW: 'Exit Preview',
  TEMPLATE_FORM_FIELDS: 'Template Form Fields',
  FILLED_DOCUMENT_PREVIEW: 'Filled Document Preview',
  NO_FORM_FIELDS_FOUND: 'No form fields found in this template',
  MORE_OPTIONS: 'More options',
  CLOSE_EDITOR: 'Close editor',
  HEADER: 'Header',
  FOOTER: 'Footer',
  TEMPLATE_HELP: 'Document Template Help',
  TEMPLATE_HELP_INTRO_1: 'Templates are easy form-like documents that you can execute multiple times.',
  TEMPLATE_HELP_INTRO_2: 'On top of the document view, you will find many editing options.',
  TEMPLATE_HELP_QUICK_TIPS: 'Quick Tips –',
  TEMPLATE_HELP_TIP_PREVIEW: "'Preview' at the bottom right will allow you to see how the completed Template will look.",
  TEMPLATE_HELP_TIP_GENERATE_PDF: "'Generate PDF' lets you view how the document will look in printed format.",
  TEMPLATE_HELP_ADVANCED: "You can create many advanced 'form-like' functions in your templates.",
  TEMPLATE_HELP_PLACEHOLDERS: 'Types of placeholders',
  ICON: 'Icon',
  USAGE: 'Usage',
  DETAILED_HELP: 'Detailed Help',
  CLICK_HERE: 'Click here',
  PUBLISH_VERSION: 'Publish this version?',
  PUBLISH_VERSION_DESCRIPTION: 'By confirming, you will save the latest changes done and this Template will be saved as a new version',
  TEMPLATE_PUBLISHED_SUCCESSFULLY: 'Template has been published successfully.',
  UNSAVED_CHANGES_TITLE: 'Unsaved changes',
  UNSAVED_CHANGES_DESCRIPTION: 'Do you want to save or discard changes?',
  TEMPLATE_DUPLICATED_SUCCESSFULLY: 'Template has been duplicated successfully.',
  BRANDING_PROFILE_SAVED_SUCCESSFULLY: 'Branding profile saved successfully.',
  BRANDING_PROFILE_DELETED_SUCCESSFULLY: 'Branding profile deleted successfully.',
  BRANDING_PROFILE_DEFAULT_UPDATED: 'Default branding profile updated successfully.',
  ADD_PROFILE: 'Add Profile',
  DEFAULT_PROFILE: 'Default',
  DELETE_PROFILE_CONFIRM_HEADER: 'Delete Branding Profile',
  DELETE_PROFILE_CONFIRM: 'Are you sure you want to delete this branding profile? This action cannot be undone.',
  MAX_PROFILES_REACHED: 'You have reached the maximum number of branding profiles allowed for your plan.',
  SEARCH_BY_PROFILE_NAME: 'Search by profile name',
  SHOW_INITIAL_TEXT: 'Show Initial Text',
  CUSTOM_REGEX_EXP_PATTERN: 'Custom regular expression pattern for validation',
  DEFAULT_TEXT_HELP: 'Default text that will be shown initially in the field',
  MIN_CHAR_LIMIT_ALLOWED: 'Minimum number of characters allowed',
  MAX_CHAR_LIMIT_ALLOWED: 'Maximum number of characters allowed',
  DEFAULT_VALUE_PRE_FILLED_FIELD: 'The default value that will be pre-filled in this field',
  DROPDOWN_VALUE_OPTION: 'Enter a value for the dropdown option',
  SLOW_LOADING_DATE_HINT: 'Loading is taking longer than usual. Try narrowing the date range above to speed things up.',
  LOADING_FILTER_HINT: 'If loading is taking time, you can filter by a shorter duration',
  DOWNLOAD_FORMFIELDS: 'Download Form Fields',
  ORDER_PLACED: 'Order Placed',
  PREPARING: 'Preparing',
  LIVE: 'Live',
  SHIPPED: 'Shipped',
  SHIPPED_WITH_DELIVERED: 'Shipped ({count} delivered)',
  DUE_DATE: 'Due Date',
  ORDER_PROGRESS: 'Order Progress',
  VENDOR_SHIPMENTS: 'Vendor shipments',
  LEVEL_1_VERIFICATION: 'Level 1 Verification',
  LEVEL_2_VERIFICATION: 'Level 2 Verification',
  CHANGED_ON: 'Changed on',
  DUE_DATE_HISTORY: 'Due date history',
  CHANGE: 'change',
  CHANGES: 'changes',
  ORDER_TRACKING_HEADER_DESCRIPTION: 'Series: {series} | Name: {name}',
  ORDER_TRACKING_HEADER_DESCRIPTION_WITH_REQUEST: '{description} | Request ID: {requestId}',
  ORDER_REQUEST_ID: 'Request ID: {requestId}',
  ORDER_DATE_AND_PAPERS: '{date} | {count} Papers',
  ORDER_DUE_DATE_WITH_VALUE: 'Due Date: {date}',
  ORDER_UPDATED_DUE_DATE_WITH_VALUE: 'Updated due date: {date}',
  DUE_DATE_HISTORY_WITH_COUNT: 'Due date history ({count} {changeLabel})',
  DUE_DATE_CHANGE_ENTRY: '{previousDate} → {newDate}',
  CHANGED_ON_WITH_DATE: 'Changed on: {date}',
  TRACKING_ID_WITH_VALUE: 'Tracking ID: {trackingId}',
  PAPERS_WITH_COUNT: '{count} Papers',
  CLICK_FOR_DETAILED_VIEW: 'Click for detailed view',
  MSG_NO_ACTIVE_ORDERS: 'No active orders found',
  INFO_RECEIVED: 'Info received',
  IN_TRANSIT: 'In Transit',
  OUT_FOR_DELIVERY: 'Out for Delivery',
  ATTEMPT_FAIL: 'Attempt failed',
  AVAILABLE_FOR_PICKUP: 'Available for pickup',
  EXCEPTION: 'Exception',
  TRACKING_ID: 'Tracking ID',
  UNKNOWN: 'Unknown',
  TRACK_SHIPMENT: 'Track shipment',
  EXPAND_VENDOR_SHIPMENTS: 'Expand to view vendor shipments',
  EXPAND_VERIFICATION: 'Expand to view verification details',
  EXPAND_SHIPMENT_DETAILS: 'Expand to view shipment details',
  N_DELIVERED: '{count} delivered',
  PAPERS: 'Papers',
  SUB_DOC_LEVEL_STAMPING: 'Sub document level stamping',
  CONFIG_ALLOW_USER_SUB_DOC_LEVEL_STAMPING: 'Allow workflow creators to configure stamping at the sub-document level (stamp series, groups, revenue, and uploads on each sub-document).',
  WORKFLOW_BUILDER_DIGITAL_STAMPING: 'Digital Stamping',
  ALLOW_USER_DIGITAL_STAMPING: 'Allow workflow creators to use digital stamping on workflows.',
  ADVANCED_SIGNING_ORDER: 'Advanced Signing Order',
  ALLOW_ADVANCED_SIGNING_ORDER: 'Allows sequential and parallel signing stages to be used within the same invitee order.',
  MULTIPLE_COMBINATIONS: 'Multiple Combinations',
  ALLOWS_MULTIPLE_COMBINATIONS_TO_BE_CONFIGURED: 'Allows multiple Combinations to be configured for the same invitee, with different documents, eSign types, and Combination-specific options.',
  LEVEL: 'Level',
  INTEGRATION_CONFIGS: 'Integration Configs',
  SETTINGS_THAT_GOVERN_HOW_EXTERNAL_SYSTEMS_INTERACT_WITH_LEEGALITY: 'Settings that govern how external systems interact with Leegality',
  DEFAULT_JOURNEY_URL_LIFETIME: 'Default journey URL lifetime',
  HOW_LONG_A_SENDERS_JOURNEY_URL_STAYS_VALID: 'How long a sender’s journey URL stays valid when your API call doesn’t specify a value.',
  ENTER_DURATION_IN_MINUTES_MAX_10080: 'Enter duration in minutes (max 10080 = 7 days)',
  ENFORCE_LINK_EXPIRY: 'Enforce link expiry',
  WHEN_ON_EVERY_INVITATION_IS_LOCKED_TO_THE_DEFAULT_LIFETIME: 'When ON, every invitation is locked to the default lifetime above, any per-call value your API sends that differs will be rejected. Use for compliance policies that mandate a single URL lifetime across the department.',
  ENTER_A_JOURNEY_URL_LIFETIME: 'Enter a duration in minutes.',
  JOURNEY_URL_LIFETIME_MUST_BE_A_WHOLE_NUMBER: 'Enter a whole number of minutes.',
  JOURNEY_URL_LIFETIME_OUT_OF_RANGE: 'Enter a value between 1 and 10080 minutes.',
};
